<template>
  <div class="c1-main ch1-main c1-chat-page" @click="c1HamMenuOpen = false; c1ShiftMenuOpen = false; c1TopTab = null">

    <!-- TOAST -->
    <transition name="ch1-toast-fade">
      <div v-if="ch1Toast" class="ch1-toast" :style="{ background: ch1Toast.color }">{{ ch1Toast.msg }}</div>
    </transition>

    <div class="c1-sticky-top">
    <!-- ═══ TOP BAR ═══ -->
    <div class="c1-tib" @click="c1SlideOpen = null">
      <!-- LEFT 25% -->
      <div class="c1-tib-side c1-tib-left" style="padding-left:0;gap:8px;">
        <div class="c1-viki-topface"
          :class="{ 'c1-viki-topface--active': c1PanelActiveContent === 'viki' }"
          @click.stop="c1SelectPanel('viki','')"
        >
          <viki-face :mood="c1VikiMood" :speaking="c1VikiSpeaking" :size="44" style="width:72px;height:44px;display:block;overflow:hidden;border-radius:0;"/>
        </div>
        <div class="c1-shift-wrap" @click.stop="c1ShiftMenuOpen = !c1ShiftMenuOpen; c1HamMenuOpen = false">
          <div class="c1-tib-shift-pill" :class="{ open: c1ShiftMenuOpen }">
            ⏱ {{ c1ShiftElapsed }}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:10px;height:10px;margin-left:3px;transition:transform .2s" :style="{ transform: c1ShiftMenuOpen ? 'rotate(180deg)' : 'rotate(0deg)' }"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
        </div>
      </div>
      <!-- CENTER 50% -->
      <div class="c1-tib-center">
        <div class="c1-tib-mod-title">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
          Chat
        </div>
        <div class="ch1-conn-dot" :class="socketStatus" :title="socketStatusLabel"></div>
      </div>
      <!-- RIGHT 25% — ham only -->
      <div class="c1-tib-side c1-tib-right">
        <div class="c1-ham-wrap" @click.stop>
          <button class="c1-ham-btn" :class="{ open: c1HamMenuOpen }" @click="c1HamMenuOpen = !c1HamMenuOpen; c1ShiftMenuOpen = false">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:18px;height:18px"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          </button>
        </div>
      </div>
    </div>
    <!-- SHIFT DRAWER -->
    <div class="c1-top-drawer c1-shift-drawer" :class="{ open: c1ShiftMenuOpen }" @click.stop>
      <div class="c1-td-inner">
        <div class="c1-td-section-lbl">My Shift</div>
        <div class="c1-td-status-row">
          <div class="c1-td-stat">
            <div class="c1-td-stat-val c1-mono">{{ c1ShiftStartTime ? new Date(c1ShiftStartTime).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }) : '—' }}</div>
            <div class="c1-td-stat-lbl">Started</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val c1-mono" style="color:var(--c1-dp)">{{ c1ShiftElapsed }}</div>
            <div class="c1-td-stat-lbl">Elapsed</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val">{{ c1BathroomCount }}×</div>
            <div class="c1-td-stat-lbl">🚽 Bathroom</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val">{{ c1CoffeeCount }}×</div>
            <div class="c1-td-stat-lbl">☕ Coffee</div>
          </div>
        </div>
        <div class="c1-td-btn-row">
          <button class="c1-td-btn c1-td-btn-shift"   :class="{ active: c1Status === 'shift' }"   @click.stop="c1SetStatus('shift')">▶ On Shift</button>
          <button class="c1-td-btn c1-td-btn-bathroom" :class="{ active: c1Status === 'bathroom' }" @click.stop="c1SetStatus('bathroom')">🚽 Bathroom</button>
          <button class="c1-td-btn c1-td-btn-coffee"  :class="{ active: c1Status === 'coffee' }"  @click.stop="c1SetStatus('coffee')">☕ Coffee</button>
          <button class="c1-td-btn c1-td-btn-break"   :class="{ active: c1Status === 'break' }"   @click.stop="c1SetStatus('break')">⏸ Break</button>
          <button class="c1-td-btn c1-td-btn-lunch"   :class="{ active: c1Status === 'lunch' }"   @click.stop="c1SetStatus('lunch')">🍽 Lunch</button>
          <button class="c1-td-btn c1-td-btn-end"     @click.stop="c1SetStatus('end')">⏹ End Shift</button>
        </div>
      </div>
    </div>
    <!-- HAM NAV DRAWER -->
    <div class="c1-top-drawer c1-ham-drawer" :class="{ open: c1HamMenuOpen }" @click.stop>
      <div class="c1-td-inner c1-td-nav-grid">
        <router-link to="/clients1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-dp)"></span>Clients</router-link>
        <router-link to="/tasks1" class="c1-td-nav-item" :class="{ on: $route.path === '/tasks1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-sc)"></span>Tasks</router-link>
        <router-link to="/stats1" class="c1-td-nav-item" :class="{ on: $route.path === '/stats1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-ld)"></span>Statistics</router-link>
        <router-link to="/chat1" class="c1-td-nav-item" :class="{ on: $route.path === '/chat1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-rf)"></span>Chat</router-link>
        <router-link to="/communications1" class="c1-td-nav-item" :class="{ on: $route.path === '/communications1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#3b82f6"></span>Communications</router-link>
        <router-link to="/affiliation1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#8b5cf6"></span>Affiliation</router-link>
        <router-link to="/finance1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#10b981"></span>Finance</router-link>
        <router-link to="/shifts1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#f59e0b"></span>Shifts</router-link>
        <router-link to="/users1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#06b6d4"></span>Users</router-link>
        <router-link to="/brokers1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#ec4899"></span>Brokers</router-link>
        <router-link to="/security1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#ef4444"></span>Security</router-link>
        <router-link to="/quiz1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#a78bfa"></span>Quiz</router-link>
        <router-link to="/instruction1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#64748b"></span>Instructions</router-link>
        <router-link to="/settings1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#94a3b8"></span>Settings</router-link>
        <router-link to="/profile1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#22d3ee"></span>My Profile</router-link>
      </div>
    </div>
    </div><!-- /c1-sticky-top -->

    <!-- ══ CHAT TOP FILTER STRIP ══ -->
    <div class="c1-top-strip" @click.stop>
      <div class="c1-top-strip-body">

        <!-- TAB ROW -->
        <div class="c1-ts-tab-row">
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'status'}" @click.stop="c1TopTab = c1TopTab === 'status' ? null : 'status'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
            <span>Status</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='status' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'agent'}" @click.stop="c1TopTab = c1TopTab === 'agent' ? null : 'agent'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>
            <span>Agent</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='agent' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'date'}" @click.stop="c1TopTab = c1TopTab === 'date' ? null : 'date'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            <span>Date</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='date' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'sort'}" @click.stop="c1TopTab = c1TopTab === 'sort' ? null : 'sort'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><line x1="3" y1="6" x2="21" y2="6"/><line x1="6" y1="12" x2="18" y2="12"/><line x1="9" y1="18" x2="15" y2="18"/></svg>
            <span>Sort</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='sort' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
        </div>

        <!-- STATUS DROPDOWN -->
        <div v-show="c1TopTab === 'status'" class="c1-ts-dropdown">
          <div class="c1-fs-section-lbl">Inbox</div>
          <div class="c1-fs-toggle" style="margin:0 8px 8px">
            <div class="c1-fs-tog-btn" :class="{ on: !ch1Filter.unreadOnly }" @click.stop="ch1Filter.unreadOnly = false; c1TopTab = null">All</div>
            <div class="c1-fs-tog-btn" :class="{ on: ch1Filter.unreadOnly }" @click.stop="ch1Filter.unreadOnly = true; c1TopTab = null">Unread only</div>
          </div>
          <div class="c1-fs-section-lbl">Type</div>
          <div class="c1-fs-toggle" style="margin:0 8px 8px">
            <div class="c1-fs-tog-btn" :class="{ on: ch1Filter.type === 'all' }" @click.stop="ch1Filter.type = 'all'; c1TopTab = null">All</div>
            <div class="c1-fs-tog-btn" :class="{ on: ch1Filter.type === 'room' }" @click.stop="ch1Filter.type = 'room'; c1TopTab = null">Rooms</div>
            <div class="c1-fs-tog-btn" :class="{ on: ch1Filter.type === 'direct' }" @click.stop="ch1Filter.type = 'direct'; c1TopTab = null">Direct</div>
          </div>
          <div class="c1-fs-section-lbl">Room / Group</div>
          <div class="ch1-room-list" style="padding:0 8px 8px;display:flex;flex-wrap:wrap;gap:6px">
            <div v-for="room in ch1AllRooms" :key="room.id" class="ch1-room-chip"
              :class="{ on: ch1Filter.roomId === room.id }"
              @click.stop="ch1Filter.roomId = ch1Filter.roomId === room.id ? null : room.id">
              <span class="ch1-room-av" :style="{ background: ch1RoomColor(room) }">{{ ch1RoomInitials(room) }}</span>
              <span class="ch1-room-nm">{{ room.name }}</span>
            </div>
          </div>
        </div>

        <!-- AGENT DROPDOWN -->
        <div v-show="c1TopTab === 'agent'" class="c1-ts-dropdown">
          <div class="c1-fs-section-lbl">User</div>
          <div class="c1-agent-grid" style="padding:0 8px 8px">
            <div v-for="user in ch1AllUsers" :key="user.id" class="c1-agent-chip"
              :class="{ on: ch1Filter.userId === user.id }"
              @click.stop="ch1Filter.userId = ch1Filter.userId === user.id ? null : user.id">
              <div class="c1-agent-av" :style="{ background: ch1UserColor(user) }">{{ ch1PersonInitials(user) }}</div>
              <span class="c1-agent-nm">{{ ch1PersonShortName(user) }}</span>
            </div>
          </div>
        </div>

        <!-- DATE DROPDOWN -->
        <div v-show="c1TopTab === 'date'" class="c1-ts-dropdown">
          <div class="c1-fs-section-lbl">Date Range</div>
          <div class="c1-fs-toggle" style="margin:0 8px 8px;flex-wrap:wrap;gap:4px">
            <div class="c1-fs-tog-btn" :class="{ on: ch1Filter.date === 'today' }" @click.stop="ch1SetDate('today'); c1TopTab = null">Today</div>
            <div class="c1-fs-tog-btn" :class="{ on: ch1Filter.date === 'week' }" @click.stop="ch1SetDate('week'); c1TopTab = null">This week</div>
            <div class="c1-fs-tog-btn" :class="{ on: ch1Filter.date === 'month' }" @click.stop="ch1SetDate('month'); c1TopTab = null">This month</div>
            <div class="c1-fs-tog-btn" :class="{ on: ch1Filter.date === 'all' }" @click.stop="ch1SetDate('all'); c1TopTab = null">All time</div>
          </div>
        </div>

        <!-- SORT DROPDOWN -->
        <div v-show="c1TopTab === 'sort'" class="c1-ts-dropdown">
          <div class="c1-fs-section-lbl">Sort by</div>
          <div class="c1-fs-toggle" style="margin:0 8px 8px">
            <div class="c1-fs-tog-btn on">Latest first</div>
          </div>
        </div>

        <div class="c1-nm-div"></div>
        <c1-mod-calendar :items="ch1Messages" dateField="created_at" itemLabel="chats" style="flex-shrink:0" />

      </div>
    </div><!-- /c1-top-strip -->

    <!-- ═══ PANEL BACKDROP ═══ -->
    <transition name="c1-bd-fade">
      <div v-if="c1SlideOpen" class="c1-panel-backdrop" @click.stop="c1SlideOpen = null"></div>
    </transition>

    <!-- ═══ UNIFIED PANEL ═══ -->
    <div class="c1-panel" :class="{ 'c1-panel--open': c1PanelIsOpen }" @click.capture="c1FilterPanelClick">
      <div class="c1-panel-track" :class="{ 'at-content': c1PanelAtContent }">

        <!-- SCREEN 0: NAV -->
        <div class="c1-panel-screen">
          <!-- User strip -->
          <div class="c1-nav-user-strip">
            <div class="c1-nav-av">
              {{ c1UserInitials }}
              <span class="c1-nav-av-dot" :class="'c1-dst-' + c1Status"></span>
            </div>
            <div class="c1-nav-uinfo">
              <div class="c1-nav-uname">{{ c1UserFullName }}</div>
              <div class="c1-nav-urole">{{ c1RoleLabel }}</div>
            </div>
            <div class="c1-nav-status-wrap" @click.stop="c1StatusMenuOpen = !c1StatusMenuOpen">
              <div class="c1-nav-status-btn" :class="'c1-st-' + c1Status">
                <span class="c1-nav-status-sdot"></span>
                <span class="c1-nav-status-elapsed">{{ c1StatusElapsed }}</span>
              </div>
              <transition name="c1-sfade">
                <div v-if="c1StatusMenuOpen" class="c1-nav-status-menu">
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('available')"><span class="c1-nav-status-opt-dot c1-st-dot-available"></span>Available</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('bathroom')"><span class="c1-nav-status-opt-dot c1-st-dot-bathroom"></span>Bathroom</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('coffee')"><span class="c1-nav-status-opt-dot c1-st-dot-coffee"></span>Coffee break</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('shift')"><span class="c1-nav-status-opt-dot c1-st-dot-shift"></span>Start shift</div>
                  <div class="c1-nav-status-opt c1-sto-end" @click.stop="c1SetStatus('end')"><span class="c1-nav-status-opt-dot c1-st-dot-end"></span>End shift</div>
                </div>
              </transition>
            </div>
          </div>

          <!-- Timezone bar -->
          <div class="c1-nav-tz-bar">
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🇬🇧</span><span class="c1-nav-tz-time">{{ c1TzUK }}</span></div>
            <div class="c1-nav-tz-sep"></div>
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🇮🇱</span><span class="c1-nav-tz-time">{{ c1TzIL }}</span></div>
            <div class="c1-nav-tz-sep"></div>
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🇰🇾</span><span class="c1-nav-tz-time">{{ c1TzCB }}</span></div>
          </div>

          <!-- NAVIGATE mode: all pages -->
          <div v-if="c1NavMode === 'navigate'" class="c1-sl-body" style="padding:6px 0 12px">
            <div class="c1-psel-sub c1-psel-sub-back" @click.stop="c1NavMode = 'panels'">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><polyline points="15 18 9 12 15 6"/></svg>
              <span class="c1-psel-sub-lbl">{{ c1CurrentPageLabel }}</span>
            <span class="c1-nav-x-btn" @click.stop="c1SlideOpen = null"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:15px;height:15px;display:block"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></span></div>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">CRM</div>
            <router-link class="c1-psel-sub" to="/clients1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Clients</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/tasks1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Tasks</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/stats1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Statistics</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/chat1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Chat</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/communications1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Communications</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/affiliation1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Affiliation</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Sales</div>
            <router-link class="c1-psel-sub" to="/finance1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Finance</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/shifts1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Shifts</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/games1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Games</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Team</div>
            <router-link class="c1-psel-sub" to="/users1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Users</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/brokers1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Brokers</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/security1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Security</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Admin</div>
            <router-link class="c1-psel-sub" to="/quiz1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Quiz</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/instruction1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Instructions</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/settings1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Settings</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/profile1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">My Profile</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
          </div>

          <!-- PANELS mode -->
          <div v-else class="c1-sl-body" style="padding:6px 0 12px">
            <!-- Navigate row -->
            <div class="c1-psel-sub c1-psel-sub-navigate" @click.stop="c1NavMode = 'navigate'">
              <span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span>
              <span class="c1-psel-sub-lbl" style="font-weight:600;color:var(--c1-dp)">{{ c1CurrentPageLabel }}</span>
              <span class="c1-psel-sub-hint">Go to another page</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
              Filters
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'filters' }" @click.stop="c1SelectPanel('filters','')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Chat Filters</span>
              <span class="c1-psel-sub-hint">Inbox, type, room, user</span>
              <svg v-if="c1PanelActiveContent === 'filters'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              Calendar
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'calendar' }" @click.stop="c1SelectPanel('calendar','')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Message Calendar</span>
              <span class="c1-psel-sub-hint">Jump to date in history</span>
              <svg v-if="c1PanelActiveContent === 'calendar'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>
              Viki
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'viki' }" @click.stop="c1SelectPanel('viki','')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Viki Assistant</span>
              <span class="c1-psel-sub-hint">Transfers, agents, notifications</span>
              <svg v-if="c1PanelActiveContent === 'viki'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
          </div>
        </div>

        <!-- SCREEN 1: CONTENT -->
        <div class="c1-panel-screen">
          <div class="c1-panel-hdr-bar">
            <div class="c1-panel-back-btn" @click="c1SlideOpen = 'nav'">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
            </div>
            <span class="c1-panel-hdr-ttl">{{ c1ActivePanelLabel }}</span>
            <div class="c1-panel-back-btn" @click="c1SlideOpen = null">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </div>
          </div>
          <div class="c1-sl-body">

            <!-- ═══ FILTERS CONTENT ═══ -->
            <template v-if="c1PanelActiveContent === 'filters'">
              <div class="c1-sl-body">
        <div class="c1-fp-group">
          <div class="c1-fp-lbl">Inbox</div>
          <div class="c1-fp-opts">
            <div class="c1-fp-opt" :class="{ on: !ch1Filter.unreadOnly }" @click="ch1Filter.unreadOnly = false; ch1SlideOpen_close()">All</div>
            <div class="c1-fp-opt" :class="{ on: ch1Filter.unreadOnly }" @click="ch1Filter.unreadOnly = true; ch1SlideOpen_close()">Unread only</div>
          </div>
        </div>
        <div class="c1-fp-group">
          <div class="c1-fp-lbl">Type</div>
          <div class="c1-fp-opts">
            <div class="c1-fp-opt" :class="{ on: ch1Filter.type === 'all' }" @click="ch1Filter.type = 'all'">All</div>
            <div class="c1-fp-opt" :class="{ on: ch1Filter.type === 'room' }" @click="ch1Filter.type = 'room'">Rooms / Groups</div>
            <div class="c1-fp-opt" :class="{ on: ch1Filter.type === 'direct' }" @click="ch1Filter.type = 'direct'">Direct Messages</div>
          </div>
        </div>
        <div class="c1-fp-group c1-fp-full">
          <div class="c1-fp-lbl">Room / Group</div>
          <div class="ch1-room-list">
            <div v-for="room in ch1AllRooms" :key="room.id" class="ch1-room-chip"
              :class="{ on: ch1Filter.roomId === room.id }"
              @click="ch1Filter.roomId = ch1Filter.roomId === room.id ? null : room.id">
              <span class="ch1-room-av" :style="{ background: ch1RoomColor(room) }">{{ ch1RoomInitials(room) }}</span>
              <span class="ch1-room-nm">{{ room.name }}</span>
            </div>
          </div>
        </div>
        <div class="c1-fp-group c1-fp-full">
          <div class="c1-fp-lbl">User</div>
          <div class="c1-agent-grid">
            <div v-for="user in ch1AllUsers" :key="user.id" class="c1-agent-chip"
              :class="{ on: ch1Filter.userId === user.id }"
              @click="ch1Filter.userId = ch1Filter.userId === user.id ? null : user.id">
              <div class="c1-agent-av" :style="{ background: ch1UserColor(user) }">{{ ch1PersonInitials(user) }}</div>
              <span class="c1-agent-nm">{{ ch1PersonShortName(user) }}</span>
            </div>
          </div>
        </div>
        <div class="c1-fp-group">
          <div class="c1-fp-lbl">Date range</div>
          <div class="c1-fp-opts">
            <div class="c1-fp-opt" :class="{ on: ch1Filter.date === 'today' }" @click="ch1SetDate('today')">Today</div>
            <div class="c1-fp-opt" :class="{ on: ch1Filter.date === 'week' }" @click="ch1SetDate('week')">This week</div>
            <div class="c1-fp-opt" :class="{ on: ch1Filter.date === 'month' }" @click="ch1SetDate('month')">This month</div>
            <div class="c1-fp-opt" :class="{ on: ch1Filter.date === 'all' }" @click="ch1SetDate('all')">All time</div>
          </div>
        </div>
              </div>
            </template>

            <!-- ═══ CALENDAR CONTENT ═══ -->
            <template v-if="c1PanelActiveContent === 'calendar'">
              <div class="c1-sl-body">
        <div class="c1-fp-lbl" style="padding:14px 14px 8px;font-size:11px">Message history — tap a day to jump</div>
        <div class="ch1-cal-nav">
          <button class="ch1-cal-nav-btn" @click="ch1CalPrev">
            <svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>
          </button>
          <span class="ch1-cal-month-lbl">{{ ch1CalMonthName }} {{ ch1Cal.year }}</span>
          <button class="ch1-cal-nav-btn" @click="ch1CalNext">
            <svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>
          </button>
        </div>
        <div class="ch1-cal-grid">
          <div v-for="d in ['Mo','Tu','We','Th','Fr','Sa','Su']" :key="d" class="ch1-cal-dow">{{ d }}</div>
          <div v-for="cell in ch1CalCells" :key="cell.key" class="ch1-cal-cell"
            :class="{ 'ch1-cal-other': !cell.inMonth, 'ch1-cal-today': cell.today, 'ch1-cal-active': ch1Cal.selected === cell.date, 'ch1-cal-has': cell.hasMessages }"
            @click="cell.inMonth && ch1JumpToDate(cell.date)">
            {{ cell.day }}
            <span v-if="cell.hasMessages" class="ch1-cal-dot"></span>
          </div>
        </div>
              </div>
            </template>

            <!-- ═══ VIKI CONTENT ═══ -->
            <template v-if="c1PanelActiveContent === 'viki'">
              <div class="c1-sl-body">
      <div class="ch1-viki-head">
        <div class="ch1-viki-title">
          <div class="ch1-viki-av">V</div>
          <div>
            <div class="ch1-viki-name">Viki</div>
            <div class="ch1-viki-sub">AI Agent Assistant</div>
          </div>
        </div>
        <div class="ch1-viki-status-dot" :class="{ active: socketStatus === 'connected' }"></div>
      </div>

      <!-- Pending transfer requests -->
      <div v-if="ch1PendingTransfers.length" class="ch1-viki-section">
        <div class="ch1-viki-section-lbl">
          <span class="ch1-viki-badge-inline">{{ ch1PendingTransfers.length }}</span>
          Live Transfer Requests
        </div>
        <div v-for="tr in ch1PendingTransfers" :key="tr.id" class="ch1-transfer-card">
          <div class="ch1-transfer-flag">{{ tr.countryFlag }}</div>
          <div class="ch1-transfer-info">
            <div class="ch1-transfer-name">{{ tr.clientName }}</div>
            <div class="ch1-transfer-meta">{{ tr.country }} · {{ tr.campaign }} · {{ ch1FmtMsgTime(tr.arrivedAt) }}</div>
          </div>
          <div class="ch1-transfer-actions">
            <button class="ch1-tr-btn ch1-tr-accept" @click="ch1AcceptTransfer(tr)">Accept</button>
            <button class="ch1-tr-btn ch1-tr-decline" @click="ch1DeclineTransfer(tr)">Decline</button>
            <button class="ch1-tr-btn ch1-tr-vp" @click="ch1AskVPSales(tr)">Ask VP</button>
          </div>
        </div>
      </div>

      <!-- VP Sales: agent selection for transfer -->
      <div v-if="ch1VPTransferMode" class="ch1-viki-section">
        <div class="ch1-viki-section-lbl">Assign transfer to agent</div>
        <div class="ch1-vp-transfer-wrap">
          <div class="ch1-vp-transfer-client">
            <strong>{{ ch1VPTransferMode.clientName }}</strong> from {{ ch1VPTransferMode.country }}
          </div>
          <div class="ch1-agent-score-list">
            <div v-for="agent in ch1AgentScores" :key="agent.id" class="ch1-agent-score-row"
              @click="ch1AssignTransferToAgent(ch1VPTransferMode, agent)">
              <div class="ch1-agent-score-av" :style="{ background: ch1UserColor(agent) }">{{ ch1PersonInitials(agent) }}</div>
              <div class="ch1-agent-score-info">
                <div class="ch1-agent-score-name">{{ agent.first_name }} {{ agent.last_name }}</div>
                <div class="ch1-agent-score-meta">
                  <span class="ch1-score-pill" :style="{ background: ch1ScoreColor(agent.score) }">{{ agent.score }}</span>
                  <span class="ch1-score-meta-item">{{ agent.transfers_today }} TR</span>
                  <span class="ch1-score-meta-item">{{ agent.deposits_today }} DP</span>
                  <span v-if="ch1IsOnline(agent.id)" class="ch1-score-online">online</span>
                </div>
              </div>
            </div>
          </div>
          <button class="ch1-vp-you-decide" @click="ch1YouDecide(ch1VPTransferMode)">You Decide</button>
          <button class="ch1-vp-cancel" @click="ch1VPTransferMode = null">Cancel</button>
        </div>
      </div>

      <!-- Online agents indicator -->
      <div class="ch1-viki-section">
        <div class="ch1-viki-section-lbl">Online agents ({{ ch1OnlineUsers.length }})</div>
        <div class="ch1-viki-agents">
          <div v-if="!ch1OnlineUsers.length" class="ch1-viki-empty">No agents currently online</div>
          <div v-for="user in ch1OnlineUsers" :key="'va-'+user.id" class="ch1-viki-agent-row"
            @click="ch1OpenDirectMessage(user)">
            <div class="ch1-viki-agent-av" :style="{ background: ch1UserColor(user) }">{{ ch1PersonInitials(user) }}</div>
            <div class="ch1-viki-agent-name">{{ user.first_name }} {{ user.last_name }}</div>
            <div class="ch1-viki-agent-dot"></div>
          </div>
        </div>
      </div>

      <!-- Notifications log -->
      <div class="ch1-viki-section">
        <div class="ch1-viki-section-lbl">Notifications</div>
        <div v-if="!ch1Notifications.length" class="ch1-viki-empty">No notifications</div>
        <div v-for="(n, ni) in ch1Notifications" :key="'n'+ni" class="ch1-notif-row" :class="'ch1-notif-' + n.type">
          <div class="ch1-notif-dot"></div>
          <div class="ch1-notif-body">
            <div class="ch1-notif-text">{{ n.text }}</div>
            <div class="ch1-notif-time">{{ ch1FmtMsgTime(n.ts) }}</div>
          </div>
        </div>
      </div>

              </div>
            </template>

          </div>
        </div>

      </div>
    </div>

    <!-- ═══ ONLINE USERS STRIP ═══ -->
    <div class="ch1-online-strip" ref="onlineStrip">
      <div v-for="user in ch1OnlineUsers" :key="user.id" class="ch1-online-av-wrap"
        :title="user.first_name + ' ' + user.last_name"
        @click="ch1OpenDirectMessage(user)">
        <div class="ch1-online-av" :style="{ background: ch1UserColor(user) }">{{ ch1PersonInitials(user) }}</div>
        <div class="ch1-online-dot"></div>
      </div>
      <div v-if="!ch1OnlineUsers.length" class="ch1-online-empty">No one else online</div>
    </div>

    <!-- ═══ MAIN SPLIT VIEW ═══ -->
    <div class="ch1-split" :class="{ 'ch1-thread-open': ch1ActiveConv !== null }">

      <!-- LEFT: Conversation list -->
      <div class="ch1-left" :class="{ 'ch1-left-hidden': ch1ActiveConv !== null }">

        <div class="ch1-list-header">
          <div class="ch1-search-wrap">
            <svg class="ch1-search-ico" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input class="ch1-search-input" v-model.trim="ch1Search" placeholder="Search conversations…" type="text" />
            <div v-if="ch1Search" class="ch1-search-clear" @click="ch1Search = ''">
              <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </div>
          </div>
          <button class="ch1-new-btn" @click="ch1NewConvOpen = !ch1NewConvOpen" title="New conversation">
            <svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          </button>
        </div>

        <!-- New conversation picker -->
        <div v-if="ch1NewConvOpen" class="ch1-new-conv-picker">
          <div class="ch1-new-conv-lbl">Start conversation with…</div>
          <div v-for="user in ch1AllUsers.filter(u => u.id !== ch1MyId)" :key="'np-'+user.id"
            class="ch1-new-conv-item" @click="ch1StartDirect(user)">
            <div class="ch1-new-conv-av" :style="{ background: ch1UserColor(user) }">{{ ch1PersonInitials(user) }}</div>
            <span class="ch1-new-conv-name">{{ user.first_name }} {{ user.last_name }}</span>
            <div v-if="ch1IsOnline(user.id)" class="ch1-new-conv-dot"></div>
          </div>
          <div class="ch1-new-conv-lbl" style="margin-top:10px">Or join a room…</div>
          <div v-for="room in ch1AllRooms" :key="'nr-'+room.id"
            class="ch1-new-conv-item" @click="ch1OpenRoom(room)">
            <div class="ch1-new-conv-av" :style="{ background: ch1RoomColor(room) }">{{ ch1RoomInitials(room) }}</div>
            <span class="ch1-new-conv-name"># {{ room.name }}</span>
          </div>
        </div>

        <!-- Conversation list -->
        <div class="ch1-conv-list" ref="convList">
          <div v-if="ch1FilteredConvs.length === 0" class="ch1-conv-empty">
            <svg viewBox="0 0 24 24"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
            <span>No conversations yet</span>
          </div>
          <div v-for="conv in ch1FilteredConvs" :key="conv.id" class="ch1-conv-item"
            :class="{ 'ch1-conv-active': ch1ActiveConv && ch1ActiveConv.id === conv.id, 'ch1-conv-unread': conv.unreadCount > 0 }"
            @click="ch1SelectConv(conv)">
            <div class="ch1-conv-av-wrap">
              <div class="ch1-conv-av" :style="{ background: ch1ConvColor(conv) }">{{ ch1ConvInitials(conv) }}</div>
              <div v-if="ch1IsOnline(conv.peerId)" class="ch1-conv-online-dot"></div>
            </div>
            <div class="ch1-conv-body">
              <div class="ch1-conv-row1">
                <span class="ch1-conv-name" :class="{ 'ch1-conv-name-bold': conv.unreadCount > 0 }">{{ conv.name }}</span>
                <span class="ch1-conv-time">{{ ch1FmtTime(conv.lastAt) }}</span>
              </div>
              <div class="ch1-conv-row2">
                <span class="ch1-conv-preview">{{ conv.lastMsg }}</span>
                <span v-if="conv.unreadCount > 0" class="ch1-conv-badge">{{ conv.unreadCount > 99 ? '99+' : conv.unreadCount }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- TEAM CHANNELS SECTION -->
        <div class="ch1-team-channels-section">
          <div class="ch1-section-hdr">TEAM CHANNELS</div>
          <div v-for="tc in ch1TeamChannelDefs()" :key="tc.channelId"
            class="ch1-team-ch-row"
            :class="{
              'ch1-team-ch-active': ch1ActiveConv && ch1ActiveConv.id === tc.channelId,
              'ch1-team-ch-locked': tc.locked
            }"
            :style="{ '--tc-color': tc.color }"
            @click="!tc.locked && ch1SelectTeamChannel(tc.channelId)"
          >
            <div class="ch1-team-ch-border" :style="{ background: tc.color }"></div>
            <div class="ch1-team-ch-av" :style="{ background: tc.color + '22', color: tc.color }">
              {{ tc.label.slice(0, 2) }}
            </div>
            <div class="ch1-team-ch-body">
              <div class="ch1-team-ch-name">{{ tc.label }}</div>
              <div class="ch1-team-ch-sub" v-if="tc.memberCount">{{ tc.memberCount }} members</div>
            </div>
            <span v-if="tc.locked" class="ch1-team-ch-lock" title="You are not in this team">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
            </span>
          </div>
        </div>

      </div>

      <!-- RIGHT: Message thread -->
      <div class="ch1-right" :class="{ 'ch1-right-visible': ch1ActiveConv !== null }">

        <div v-if="!ch1ActiveConv" class="ch1-no-conv">
          <svg viewBox="0 0 24 24"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
          <span>Select a conversation</span>
        </div>

        <template v-else>
          <!-- Thread header -->
          <div class="ch1-thread-hdr" :class="{ 'ch1-thread-hdr-team': ch1ActiveConv.type === 'team' }" :style="ch1ActiveConv.type === 'team' ? { borderBottom: '2px solid ' + ch1ActiveConv.color } : {}">
            <button class="ch1-back-btn" @click="ch1ActiveConv = null; ch1TeamChannel = null">
              <svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>
            </button>
            <div class="ch1-thread-av" :style="{ background: ch1ActiveConv.type === 'team' ? ch1ActiveConv.color : ch1ConvColor(ch1ActiveConv) }">{{ ch1ActiveConv.type === 'team' ? ch1ActiveConv.name.slice(0,2) : ch1ConvInitials(ch1ActiveConv) }}</div>
            <div class="ch1-thread-meta">
              <div class="ch1-thread-name">{{ ch1ActiveConv.name }}</div>
              <div v-if="ch1ActiveConv.type === 'team'" class="ch1-thread-sub ch1-team-sub">
                <span class="ch1-team-badge" :style="{ background: ch1ActiveConv.color + '22', color: ch1ActiveConv.color }">Team Channel</span>
                <span v-if="ch1TeamChannelDefs().find(t => t.channelId === ch1ActiveConv.id) && ch1TeamChannelDefs().find(t => t.channelId === ch1ActiveConv.id).memberCount" class="ch1-team-member-count">· {{ ch1TeamChannelDefs().find(t => t.channelId === ch1ActiveConv.id).memberCount }} members</span>
              </div>
              <div v-else-if="ch1ActiveConv.type === 'room'" class="ch1-thread-sub">
                {{ ch1RoomMemberCount(ch1ActiveConv) }} members
              </div>
              <div v-else class="ch1-thread-sub-status">
                <span class="ch1-shift-dot" :class="ch1IsOnShift(ch1ActiveConv.peerId) ? 'on' : 'off'"></span>
                <span :class="ch1IsOnShift(ch1ActiveConv.peerId) ? 'ch1-shift-live' : 'ch1-shift-off'">
                  {{ ch1IsOnShift(ch1ActiveConv.peerId) ? 'On Shift' : 'Off Shift' }}
                </span>
                <span v-if="ch1IsOnline(ch1ActiveConv.peerId)" class="ch1-online-pill">● Live</span>
              </div>
            </div>
            <div class="c1-hp"></div>
            <!-- Thread actions -->
            <button class="ch1-thread-action-btn" @click="ch1ShowStats = !ch1ShowStats" :class="{ on: ch1ShowStats }" title="Agent stats">
              <svg viewBox="0 0 24 24"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
            </button>
          </div>

          <!-- Pinned messages slot (team channels only) -->
          <div v-if="ch1ActiveConv.type === 'team'" class="ch1-pinned-slot">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px;flex-shrink:0"><line x1="12" y1="17" x2="12" y2="22"/><path d="M5 17H19V13L17 9V3H7V9L5 13Z"/></svg>
            <span class="ch1-pinned-lbl">Pinned</span>
            <span class="ch1-pinned-empty">No pinned messages</span>
          </div>

          <!-- Agent stats panel (collapsible inside thread) -->
          <div v-if="ch1ShowStats" class="ch1-stats-bar">
            <div class="ch1-stats-title">Today's chat stats</div>
            <div class="ch1-stats-grid">
              <div class="ch1-stat-card" style="--sc:#3b82f6">
                <div class="ch1-stat-val">{{ ch1AgentStats.scheduledCalls }}</div>
                <div class="ch1-stat-lbl">Scheduled</div>
              </div>
              <div class="ch1-stat-card" style="--sc:#f59e0b">
                <div class="ch1-stat-val">{{ ch1AgentStats.leads }}</div>
                <div class="ch1-stat-lbl">Leads</div>
              </div>
              <div class="ch1-stat-card" style="--sc:#22c55e">
                <div class="ch1-stat-val">{{ ch1AgentStats.deposits }}</div>
                <div class="ch1-stat-lbl">Deposits</div>
              </div>
              <div class="ch1-stat-card" style="--sc:#ef4444">
                <div class="ch1-stat-val">{{ ch1AgentStats.naAmount }}</div>
                <div class="ch1-stat-lbl">NA</div>
              </div>
              <div class="ch1-stat-card" style="--sc:#8b5cf6">
                <div class="ch1-stat-val">{{ ch1AgentStats.transfers }}</div>
                <div class="ch1-stat-lbl">Transfers</div>
              </div>
              <div class="ch1-stat-card" style="--sc:#06b6d4">
                <div class="ch1-stat-val">{{ ch1AgentStats.referrals }}</div>
                <div class="ch1-stat-lbl">Referrals</div>
              </div>
              <div class="ch1-stat-card" style="--sc:#ec4899">
                <div class="ch1-stat-val">{{ ch1AgentStats.registrations }}</div>
                <div class="ch1-stat-lbl">Registrations</div>
              </div>
              <div class="ch1-stat-card" style="--sc:#10b981">
                <div class="ch1-stat-val">{{ ch1AgentStats.assigned }}</div>
                <div class="ch1-stat-lbl">Assigned</div>
              </div>
            </div>
          </div>

          <!-- Messages scroll area -->
          <div class="ch1-messages" ref="messagesEl" @scroll="ch1OnMsgScroll">
            <div v-if="ch1LoadingMessages" class="ch1-msgs-loading">
              <div class="ch1-spinner"></div>
            </div>

            <template v-for="(group, gi) in ch1MessageGroups">
              <div :key="'sep-' + gi" class="ch1-date-sep" :data-date="group.date" :ref="'datesep_' + group.date">
                <span>{{ ch1FmtDateSep(group.date) }}</span>
              </div>
              <div v-for="msg in group.messages" :key="msg.id"
                class="ch1-msg-row" :class="{ 'ch1-msg-own': msg.senderId === ch1MyId }">
                <div v-if="msg.senderId !== ch1MyId && msg.showAvatar" class="ch1-msg-av"
                  :style="{ background: ch1SenderColor(msg.senderId) }">{{ ch1SenderInitials(msg.senderId) }}</div>
                <div v-else-if="msg.senderId !== ch1MyId && !msg.showAvatar" class="ch1-msg-av-spacer"></div>
                <div class="ch1-msg-wrap">
                  <div v-if="msg.senderId !== ch1MyId && msg.showAvatar" class="ch1-msg-sender-name">{{ ch1SenderName(msg.senderId) }}</div>
                  <!-- File attachment bubble -->
                  <div v-if="msg.fileUrl" class="ch1-bubble" :class="msg.senderId === ch1MyId ? 'ch1-bubble-own' : 'ch1-bubble-other'">
                    <div class="ch1-file-msg">
                      <svg viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                      <a :href="msg.fileUrl" target="_blank" class="ch1-file-link">{{ msg.fileName || 'Attachment' }}</a>
                      <span class="ch1-file-size">{{ msg.fileSize }}</span>
                    </div>
                    <span class="ch1-bubble-ts">{{ ch1FmtMsgTime(msg.createdAt) }}</span>
                  </div>
                  <!-- Voice message bubble -->
                  <div v-else-if="msg.isVoice" class="ch1-bubble" :class="msg.senderId === ch1MyId ? 'ch1-bubble-own' : 'ch1-bubble-other'">
                    <div class="ch1-voice-msg">
                      <button class="ch1-voice-play" @click="ch1PlayVoice(msg)">
                        <svg viewBox="0 0 24 24"><polygon points="5 3 19 12 5 21 5 3"/></svg>
                      </button>
                      <div class="ch1-voice-wave">
                        <span v-for="n in 12" :key="n" class="ch1-wave-bar" :style="{ height: (20 + Math.sin(n * 1.3) * 10) + 'px' }"></span>
                      </div>
                      <span class="ch1-voice-dur">{{ msg.duration || '0:00' }}</span>
                    </div>
                    <span class="ch1-bubble-ts">{{ ch1FmtMsgTime(msg.createdAt) }}</span>
                  </div>
                  <!-- Text bubble -->
                  <div v-else class="ch1-bubble" :class="msg.senderId === ch1MyId ? 'ch1-bubble-own' : 'ch1-bubble-other'">
                    <span class="ch1-bubble-text">{{ msg.text }}</span>
                    <span class="ch1-bubble-ts">{{ ch1FmtMsgTime(msg.createdAt) }}</span>
                  </div>
                </div>
              </div>
            </template>

            <!-- Typing indicator -->
            <div v-if="ch1TypingUsers.length" class="ch1-typing-row">
              <div class="ch1-typing-bubble">
                <span class="ch1-typing-name">{{ ch1TypingLabel }}</span>
                <span class="ch1-typing-dots"><span></span><span></span><span></span></span>
              </div>
            </div>

            <div ref="msgBottom"></div>
          </div>

          <!-- Input bar -->
          <div class="ch1-input-bar">
            <!-- File attach button -->
            <button class="ch1-attach-btn" @click="$refs.fileInput.click()" title="Attach file">
              <svg viewBox="0 0 24 24"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>
            </button>
            <input ref="fileInput" type="file" style="display:none" @change="ch1HandleFileAttach" />
            <!-- Voice message button -->
            <button class="ch1-voice-btn" :class="{ recording: ch1IsRecording }" @click="ch1ToggleRecording" title="Voice message">
              <svg viewBox="0 0 24 24"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>
            </button>
            <textarea class="ch1-textarea" ref="inputArea" v-model="ch1Draft"
              :placeholder="'Message ' + ch1ActiveConv.name + '…'"
              rows="1"
              @keydown="ch1OnKeydown"
              @input="ch1OnInput"
            ></textarea>
            <button class="ch1-send-btn" :class="{ active: ch1Draft.trim().length > 0 }"
              :disabled="!ch1Draft.trim()" @click="ch1SendMessage">
              <svg viewBox="0 0 24 24"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
            </button>
          </div>
          <div class="ch1-input-hint">Ctrl+Enter to send · 📎 attach · 🎤 voice</div>
        </template>
      </div>
    </div>

  </div>
</template>

<script>
import VikiFace from "../../clients1.feature/VikiFace.vue";
import C1ModCalendar from '../../../components/C1ModCalendar.vue';

// Socket.IO — use global io from window (loaded via CDN in index.html)
let io = (typeof window !== 'undefined' && window.io) ? window.io : null;

const API = '/api';
function apiHeaders() {
  return { 'Content-Type': 'application/json', Authorization: 'Bearer ' + (localStorage.getItem('user-token') || '') };
}

export default {
  name: 'Chat1Container',

  components: { VikiFace, C1ModCalendar },

  data() {
    return {
      c1Status: 'available',
      c1StatusSince: 0,
      c1StatusElapsed: '00:00',
      c1StatusMenuOpen: false,
      _c1StatusInterval: null,
      c1HamMenuOpen: false,
      c1ShiftMenuOpen: false,
      c1ShiftElapsed: '00:00',
      c1ShiftStartTime: 0,
      c1BathroomCount: 0,
      c1CoffeeCount: 0,
      c1WeekLog: [],
      // ── Panel / slide state ────────────────────
      c1TopTab: null,
      c1NavMode: 'panels',
      c1VikiMood: 'neutral',
      c1VikiSpeaking: false,
      c1SlideOpen: null,
      c1PanelActiveContent: null,

      // ── Socket ────────────────────────────────
      socket: null,
      socketStatus: 'disconnected',

      // ── Online / presence ─────────────────────
      ch1OnlineUserIds: [],
      ch1UsersOnShift: [],

      // ── Clock ─────────────────────────────────
      ch1TimeStr: '',

      // ── Calendar ──────────────────────────────
      ch1Cal: { year: new Date().getFullYear(), month: new Date().getMonth(), selected: null },

      // ── Filters ───────────────────────────────
      ch1Filter: { unreadOnly: false, roomId: null, userId: null, date: 'all', type: 'all' },
      ch1Search: '',

      // ── Conversations ─────────────────────────
      ch1Conversations: [],
      ch1ActiveConv: null,

      // ── Messages ──────────────────────────────
      ch1Messages: [],
      ch1LoadingMessages: false,

      // ── Input ─────────────────────────────────
      ch1Draft: '',
      ch1NewConvOpen: false,

      // ── Typing ────────────────────────────────
      ch1TypingUsers: [],
      ch1TypingTimer: null,
      ch1IsTypingEmitted: false,

      // ── Voice recording ───────────────────────
      ch1IsRecording: false,
      ch1MediaRecorder: null,
      ch1RecordChunks: [],

      // ── Users / rooms ─────────────────────────
      ch1AllUsers: [],
      ch1AllRooms: [
        { id: 'room_general', name: 'General', color: '#6366f1' },
        { id: 'room_sales',   name: 'Sales',   color: '#10b981' },
        { id: 'room_support', name: 'Support', color: '#f59e0b' },
        { id: 'room_vp',      name: 'VP Sales', color: '#ef4444' }
      ],

      // ── Viki / transfers ──────────────────────
      ch1PendingTransfers: [],
      ch1VPTransferMode: null,
      ch1AgentScores: [],
      ch1Notifications: [],

      // ── Thread stats ──────────────────────────
      ch1ShowStats: false,
      ch1AgentStats: {
        scheduledCalls: 0, leads: 0, deposits: 0,
        naAmount: 0, transfers: 0, referrals: 0,
        registrations: 0, assigned: 0
      },

      // ── Toast ─────────────────────────────────
      ch1Toast: null,
      _ch1ToastTimer: null,

      // ── Avatar color palette ──────────────────
      ch1AvatarColors: ['#6366f1','#10b981','#f59e0b','#ef4444','#8b5cf6','#06b6d4','#ec4899','#14b8a6'],

      // ── Team Channels ─────────────────────────
      ch1TeamChannel: null,    // 'team_1' | 'team_2' | null — currently active team channel
      ch1TeamsInfo: []         // from /api/admin/teams
    };
  },

  computed: {
    c1CurrentPageLabel() {
      const map = {
        '/clients1':'Clients', '/tasks1':'Tasks', '/stats1':'Statistics',
        '/chat1':'Chat', '/communications1':'Communications', '/affiliation1':'Affiliation',
        '/finance1':'Finance', '/shifts1':'Shifts', '/games1':'Games',
        '/users1':'Users', '/brokers1':'Brokers', '/security1':'Security',
        '/quiz1':'Quiz', '/instruction1':'Instructions', '/settings1':'Settings', '/profile1':'My Profile',
      };
      return map[this.$route.path] || 'Menu';
    },
    c1UserInitials() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      if (!u) return "?";
      return ((u.first_name || "")[0] || "").toUpperCase() + ((u.last_name || "")[0] || "").toUpperCase();
    },
    c1UserFullName() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      if (!u) return "User";
      return [u.first_name, u.last_name].filter(Boolean).join(" ") || "User";
    },
    c1RoleLabel() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      if (!u) return "";
      const map = { admin: "Admin", manager: "Manager", agent: "Agent", broker: "Broker" };
      return map[u.role] || u.role || "";
    },
    c1TzUK() { return this.c1TzTime("Europe/London"); },
    c1TzIL() { return this.c1TzTime("Asia/Jerusalem"); },
    c1TzCB() { return this.c1TzTime("America/Cayman"); },

    c1PanelIsOpen() {
      return !!this.c1SlideOpen && this.c1SlideOpen !== 'menu';
    },
    c1PanelAtContent() {
      return this.c1PanelIsOpen && this.c1SlideOpen !== 'nav';
    },
    c1ActivePanelLabel() {
      if (!this.c1PanelIsOpen || this.c1SlideOpen === 'nav') return 'Panels';
      const map = { filters: 'Filters', calendar: 'Calendar', viki: 'Viki' };
      return (this.c1PanelActiveContent && map[this.c1PanelActiveContent]) || 'Panels';
    },

    ch1CurrentUser() {
      return (this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user) || {};
    },
    ch1MyId() { return this.ch1CurrentUser.id || null; },
    ch1UserInitials() {
      const u = this.ch1CurrentUser;
      return ((u.first_name||'')[0]||'').toUpperCase() + ((u.last_name||'')[0]||'').toUpperCase() || '?';
    },
    socketStatusLabel() {
      return {connected:'Connected',connecting:'Connecting…',disconnected:'Offline'}[this.socketStatus]||'';
    },
    ch1CalMonthName() {
      return ['January','February','March','April','May','June','July','August','September','October','November','December'][this.ch1Cal.month];
    },
    ch1CalCells() {
      const { year, month } = this.ch1Cal;
      const first = new Date(year, month, 1);
      const dow = (first.getDay() + 6) % 7;
      const cells = [];
      const today = this._ch1DateStr(new Date());
      for (let i = dow - 1; i >= 0; i--) {
        const d = new Date(year, month, -i);
        cells.push({ key:'pre'+i, date:this._ch1DateStr(d), day:d.getDate(), inMonth:false, today:false, hasMessages:false });
      }
      const daysInMonth = new Date(year, month + 1, 0).getDate();
      for (let d = 1; d <= daysInMonth; d++) {
        const dateStr = this._ch1DateStr(new Date(year, month, d));
        const hasMessages = this.ch1Messages.some(m => m.createdAt && m.createdAt.startsWith(dateStr));
        cells.push({ key:'cur'+d, date:dateStr, day:d, inMonth:true, today:dateStr===today, hasMessages });
      }
      while (cells.length < 42) {
        const d = new Date(year, month + 1, cells.length - dow - daysInMonth + 1);
        cells.push({ key:'post'+cells.length, date:this._ch1DateStr(d), day:d.getDate(), inMonth:false, today:false, hasMessages:false });
      }
      return cells;
    },
    ch1OnlineUsers() {
      return this.ch1AllUsers.filter(u => this.ch1OnlineUserIds.includes(u.id));
    },
    ch1FilteredConvs() {
      let list = this.ch1Conversations;
      if (this.ch1Filter.unreadOnly) list = list.filter(c => c.unreadCount > 0);
      if (this.ch1Filter.type === 'room') list = list.filter(c => c.type === 'room');
      if (this.ch1Filter.type === 'direct') list = list.filter(c => c.type === 'direct');
      if (this.ch1Filter.roomId) list = list.filter(c => c.roomId === this.ch1Filter.roomId);
      if (this.ch1Filter.userId) list = list.filter(c => c.peerId === this.ch1Filter.userId);
      if (this.ch1Search) {
        const q = this.ch1Search.toLowerCase();
        list = list.filter(c => (c.name||'').toLowerCase().includes(q) || (c.lastMsg||'').toLowerCase().includes(q));
      }
      return list.slice().sort((a, b) => (b.lastAt||0) - (a.lastAt||0));
    },
    ch1MessageGroups() {
      const msgs = this.ch1Messages.slice().sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
      const groups = [];
      let lastDate = null, lastSenderId = null;
      for (const msg of msgs) {
        const date = msg.createdAt ? msg.createdAt.slice(0,10) : 'unknown';
        if (date !== lastDate) { groups.push({ date, messages:[] }); lastDate = date; lastSenderId = null; }
        const showAvatar = msg.senderId !== lastSenderId;
        groups[groups.length-1].messages.push({ ...msg, showAvatar });
        lastSenderId = msg.senderId;
      }
      return groups;
    },
    ch1TypingLabel() {
      if (!this.ch1TypingUsers.length) return '';
      const names = this.ch1TypingUsers.map(id => this.ch1SenderName(id));
      return names.length === 1 ? names[0]+' is typing' : names.slice(0,2).join(', ')+' are typing';
    }
  },

  watch: {
    ch1ActiveConv(conv) {
      if (!conv) return;
      this.ch1ShowStats = false;
      this.$nextTick(() => this.ch1ScrollToBottom(false));
    },
    ch1Messages() {
      this.$nextTick(() => this.ch1ScrollToBottom(true));
    },
    'c1SlideOpen': function(val) {
      if (val && val !== 'nav' && val !== 'menu') {
        this.c1PanelActiveContent = val;
      }
    }
  },

  created() {
    if (sessionStorage.getItem('c1keepNav')) { sessionStorage.removeItem('c1keepNav'); this.c1SlideOpen = 'nav'; this.c1NavMode = 'panels'; }
    sessionStorage.removeItem('c1openPanel');
    const tick = () => {
      const d = new Date();
      this.ch1TimeStr = [d.getHours(), d.getMinutes(), d.getSeconds()].map(n => String(n).padStart(2,'0')).join(':');
    };
    tick();
    this._ch1ClockInterval = setInterval(tick, 1000);
    this._ch1LoadUsers();
    this._ch1Connect();
    this._ch1FetchAgentStats();
    this._ch1FetchShifts();
    this._ch1FetchTeams();
    // Clear the global nav badge when chat is opened
    this.$store.commit('main/SET_CHAT_UNREAD', 0);
  },

  beforeDestroy() {
    if (this._c1StatusInterval) clearInterval(this._c1StatusInterval);
    clearInterval(this._ch1ClockInterval);
    if (this.socket) { this.socket.disconnect(); this.socket = null; }
  },

  mounted() {
    // Shift tracking
    const savedStatus = localStorage.getItem('c1_status');
    const savedSince  = localStorage.getItem('c1_status_since');
    const today = new Date().toISOString().slice(0, 10);
    const savedShiftDay = localStorage.getItem('c1_shift_day');
    if (savedShiftDay !== today) {
      if (!this.c1Status) this.c1Status = 'shift';
      this.c1ShiftStartTime = Date.now();
      this.c1BathroomCount = 0;
      this.c1CoffeeCount = 0;
      localStorage.setItem('c1_status', 'shift');
      localStorage.setItem('c1_status_since', String(Date.now()));
      localStorage.setItem('c1_shift_start', String(Date.now()));
      localStorage.setItem('c1_shift_day', today);
      localStorage.setItem('c1_bathroom_count', '0');
      localStorage.setItem('c1_coffee_count', '0');
    } else {
      if (savedStatus && !this.c1Status) this.c1Status = savedStatus;
      this.c1ShiftStartTime = parseInt(localStorage.getItem('c1_shift_start') || String(Date.now()), 10);
      this.c1BathroomCount = parseInt(localStorage.getItem('c1_bathroom_count') || '0', 10);
      this.c1CoffeeCount   = parseInt(localStorage.getItem('c1_coffee_count') || '0', 10);
    }
    this.c1StatusSince = savedSince ? parseInt(savedSince, 10) : Date.now();
    this._c1StatusInterval = setInterval(this.c1TickStatus, 1000);
    document.documentElement.style.setProperty('--gnm-sw', '0px');
  },

  methods: {
    c1SetStatus(s) {
      if (s === 'bathroom') this.c1BathroomCount++;
      if (s === 'coffee')   this.c1CoffeeCount++;
      if (!this.c1Status) this.c1Status = 'shift';
      this.c1Status = s;
      this.c1StatusSince = Date.now();
      this.c1StatusElapsed = '00:00';
      this.c1ShiftMenuOpen = false;
      localStorage.setItem('c1_status', s);
      localStorage.setItem('c1_status_since', String(this.c1StatusSince));
      if (s === 'bathroom') localStorage.setItem('c1_bathroom_count', String(this.c1BathroomCount));
      if (s === 'coffee')   localStorage.setItem('c1_coffee_count',   String(this.c1CoffeeCount));
      if (s === 'end') this.c1SaveTodayToLog();
    },
    c1TickStatus() {
      const fmtSec = (sec) => {
        const h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60), s2 = sec % 60;
        return h > 0
          ? String(h).padStart(2,'0') + ':' + String(m).padStart(2,'0') + ':' + String(s2).padStart(2,'0')
          : String(m).padStart(2,'0') + ':' + String(s2).padStart(2,'0');
      };
      this.c1StatusElapsed = fmtSec(Math.floor((Date.now() - this.c1StatusSince) / 1000));
      this.c1ShiftElapsed  = fmtSec(Math.floor((Date.now() - this.c1ShiftStartTime) / 1000));
    },
    c1SaveTodayToLog() {
      try {
        const today = new Date().toISOString().slice(0, 10);
        const workedMin = Math.floor((Date.now() - this.c1ShiftStartTime) / 60000);
        const log = JSON.parse(localStorage.getItem('c1_week_log') || '[]').filter(r => r.date !== today);
        log.unshift({ date: today, workedMin: Math.max(0, workedMin), bathroom: this.c1BathroomCount, coffee: this.c1CoffeeCount });
        localStorage.setItem('c1_week_log', JSON.stringify(log.slice(0, 14)));
        this.c1WeekLog = log.slice(0, 14);
      } catch(e) {}
    },
    c1TzTime(tz) {
      try {
        return new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", timeZone: tz });
      } catch(e) { return "--:--"; }
    },
    c1Logout() {
      this.$store.dispatch('user/logOut');
    },

    c1PanelBtnClick() {
      this.c1SlideOpen = this.c1PanelIsOpen ? null : 'nav';
    },
    c1SelectPanel(panel) {
      this.c1SlideOpen = panel;
    },
    c1FilterPanelClick(e) {
      // Panel stays open after selecting a filter option — user uses back (←) or X to navigate/close
    },

    // ══════════════════════════════════════════
    // SOCKET
    // ══════════════════════════════════════════
    _ch1Connect() {
      if (!io) { this.socketStatus = 'disconnected'; return; }
      const token = (this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.token) || localStorage.getItem('user-token') || '';
      this.socketStatus = 'connecting';
      try {
        this.socket = io('/viki', {
          path: '/socket.io/',
          transports: ['websocket', 'polling'],
          auth: { token },
          reconnectionDelay: 2000,
          reconnectionAttempts: 10
        });
        this.socket.on('connect',       () => { this.socketStatus = 'connected'; this._ch1OnSocketConnect(); });
        this.socket.on('disconnect',    () => { this.socketStatus = 'disconnected'; });
        this.socket.on('connect_error', () => { this.socketStatus = 'disconnected'; });

        // Chat messages
        this.socket.on('chat:message', (msg) => {
          if (this.ch1ActiveConv && msg.convId === this.ch1ActiveConv.id) {
            this.ch1Messages.push(msg);
          } else {
            this._ch1IncrUnread(msg.convId);
          }
          this._ch1UpdateConvPreview(msg.convId, msg);
        });

        // Typing
        this.socket.on('chat:typing', ({ convId, userId, isTyping }) => {
          if (!this.ch1ActiveConv || this.ch1ActiveConv.id !== convId) return;
          if (userId === this.ch1MyId) return;
          if (isTyping && !this.ch1TypingUsers.includes(userId)) this.ch1TypingUsers.push(userId);
          else if (!isTyping) this.ch1TypingUsers = this.ch1TypingUsers.filter(id => id !== userId);
          clearTimeout(this[`_typingClear_${userId}`]);
          if (isTyping) this[`_typingClear_${userId}`] = setTimeout(() => {
            this.ch1TypingUsers = this.ch1TypingUsers.filter(id => id !== userId);
          }, 4000);
        });

        // Online presence
        this.socket.on('chat:online',       (ids) => { this.ch1OnlineUserIds = ids || []; });
        this.socket.on('chat:user_online',  (id)  => { if (!this.ch1OnlineUserIds.includes(id)) this.ch1OnlineUserIds.push(id); });
        this.socket.on('chat:user_offline', (id)  => { this.ch1OnlineUserIds = this.ch1OnlineUserIds.filter(x => x !== id); });

        // Message history
        this.socket.on('chat:history', ({ convId, messages }) => {
          if (this.ch1ActiveConv && this.ch1ActiveConv.id === convId) {
            this.ch1Messages = messages || [];
            this.ch1LoadingMessages = false;
          }
        });

        // Transfer requests from Viki
        this.socket.on('transfer_request', (data) => {
          this._ch1HandleTransferRequest(data);
        });

        // New message notification
        this.socket.on('new_message', (msg) => {
          if (this.ch1ActiveConv && msg.convId === this.ch1ActiveConv.id) {
            this.ch1Messages.push(msg);
          } else {
            this._ch1IncrUnread(msg.convId);
            this._ch1AddNotification('message', `New message from ${msg.senderName || 'someone'}`);
            // Increment global bell
            const cur = this.$store.getters['main/chatUnread'] || 0;
            this.$store.commit('main/SET_CHAT_UNREAD', cur + 1);
          }
        });

        // Pending unread messages on login — build conversations list from stored messages
        this.socket.on('chat:pending', (pendingList) => {
          if (!Array.isArray(pendingList) || !pendingList.length) return;
          let totalUnread = 0;
          pendingList.forEach(p => {
            totalUnread += p.count || 0;
            // Find the peer user to build a conversation entry
            const peerId = p.fromId;
            const existing = this.ch1Conversations.find(c => c.id === p.convId);
            if (existing) {
              existing.unreadCount = (existing.unreadCount || 0) + (p.count || 0);
              existing.lastMsg = p.lastMsg || existing.lastMsg;
            } else {
              const peer = this.ch1Users.find(u => u.id === peerId) || { id: peerId, name: 'Agent ' + peerId, avatar: null };
              this.ch1Conversations.unshift({
                id: p.convId,
                type: 'direct',
                name: peer.name || peer.full_name || ('Agent ' + peerId),
                avatar: peer.avatar || peer.photo || null,
                peerId,
                unreadCount: p.count || 0,
                lastMsg: p.lastMsg || '',
                lastAt: p.lastAt || null
              });
            }
          });
          // Update global nav bell via Vuex
          if (totalUnread > 0 && this.$store) {
            this.$store.commit('main/SET_CHAT_UNREAD', totalUnread);
          }
        });

      } catch (err) {
        this.socketStatus = 'disconnected';
      }
    },

    _ch1OnSocketConnect() {
      // Identify this agent to the chat system
      if (this.ch1MyId) {
        this.socket.emit('chat:auth', { userId: this.ch1MyId });
      }
      // Join all current conversations
      for (const conv of this.ch1Conversations) {
        this.socket.emit('chat:join', { convId: conv.id });
      }
      // Announce online status
      this.socket.emit('chat:status', { online: this.ch1UserOnline });
    },

    // ══════════════════════════════════════════
    // CONVERSATIONS
    // ══════════════════════════════════════════
    ch1SelectConv(conv) {
      this.ch1ActiveConv = conv;
      this.ch1NewConvOpen = false;
      conv.unreadCount = 0;
      this.ch1LoadingMessages = true;
      this.ch1Messages = [];
      this.ch1TypingUsers = [];
      if (this.socket && this.socket.connected) {
        this.socket.emit('chat:join', { convId: conv.id });
        this.socket.emit('chat:get_history', { convId: conv.id, limit: 80 });
      } else {
        this.ch1LoadingMessages = false;
      }
      // Safety timeout — if socket never responds, clear the spinner after 5s
      clearTimeout(this._ch1LoadTimeout);
      this._ch1LoadTimeout = setTimeout(() => {
        if (this.ch1LoadingMessages) this.ch1LoadingMessages = false;
      }, 5000);
    },

    ch1OpenDirectMessage(user) {
      const existing = this.ch1Conversations.find(c => c.type === 'direct' && c.peerId === user.id);
      if (existing) { this.ch1SelectConv(existing); return; }
      const conv = {
        id: 'direct_' + this.ch1MyId + '_' + user.id,
        type: 'direct',
        name: user.first_name + ' ' + user.last_name,
        peerId: user.id,
        lastMsg: '', lastAt: Date.now(), unreadCount: 0
      };
      this.ch1Conversations.unshift(conv);
      this.ch1SelectConv(conv);
    },

    ch1StartDirect(user) { this.ch1NewConvOpen = false; this.ch1OpenDirectMessage(user); },

    ch1OpenRoom(room) {
      this.ch1NewConvOpen = false;
      const existing = this.ch1Conversations.find(c => c.type === 'room' && c.roomId === room.id);
      if (existing) { this.ch1SelectConv(existing); return; }
      const conv = {
        id: room.id, type: 'room', name: '# ' + room.name,
        roomId: room.id, lastMsg: '', lastAt: Date.now(), unreadCount: 0
      };
      this.ch1Conversations.unshift(conv);
      this.ch1SelectConv(conv);
    },

    ch1RoomMemberCount(conv) {
      if (conv.type !== 'room') return 0;
      return this.ch1AllUsers.length;
    },

    // ══════════════════════════════════════════
    // SEND / INPUT
    // ══════════════════════════════════════════
    ch1SendMessage() {
      const text = this.ch1Draft.trim();
      if (!text || !this.ch1ActiveConv) return;
      const msg = {
        id: 'local_' + Date.now() + '_' + Math.random().toString(36).slice(2),
        convId: this.ch1ActiveConv.id,
        senderId: this.ch1MyId,
        text,
        createdAt: new Date().toISOString()
      };
      this.ch1Messages.push(msg);
      this._ch1UpdateConvPreview(this.ch1ActiveConv.id, msg);
      this.ch1Draft = '';
      this.$nextTick(() => {
        if (this.$refs.inputArea) this.$refs.inputArea.style.height = 'auto';
        this.ch1ScrollToBottom(false);
      });
      if (this.socket && this.socket.connected) {
        this.socket.emit('send_message', {
          to: this.ch1ActiveConv.peerId || this.ch1ActiveConv.roomId || null,
          text,
          convId: this.ch1ActiveConv.id,
          type: this.ch1ActiveConv.type
        });
        this._ch1StopTyping();
      }
    },

    ch1OnKeydown(e) {
      if (e.key === 'Enter' && e.ctrlKey) { e.preventDefault(); this.ch1SendMessage(); }
    },

    ch1OnInput(e) {
      const el = e.target;
      el.style.height = 'auto';
      el.style.height = Math.min(el.scrollHeight, 140) + 'px';
      if (this.socket && this.socket.connected && this.ch1ActiveConv) {
        if (!this.ch1IsTypingEmitted) {
          this.ch1IsTypingEmitted = true;
          this.socket.emit('chat:typing', { convId: this.ch1ActiveConv.id, isTyping: true });
        }
        clearTimeout(this.ch1TypingTimer);
        this.ch1TypingTimer = setTimeout(() => this._ch1StopTyping(), 2500);
      }
    },

    _ch1StopTyping() {
      if (this.ch1IsTypingEmitted && this.socket && this.socket.connected && this.ch1ActiveConv) {
        this.socket.emit('chat:typing', { convId: this.ch1ActiveConv.id, isTyping: false });
      }
      this.ch1IsTypingEmitted = false;
      clearTimeout(this.ch1TypingTimer);
    },

    // ══════════════════════════════════════════
    // FILE ATTACHMENT
    // ══════════════════════════════════════════
    ch1HandleFileAttach(e) {
      const file = e.target.files && e.target.files[0];
      if (!file || !this.ch1ActiveConv) return;
      const objectUrl = URL.createObjectURL(file);
      const msg = {
        id: 'file_' + Date.now(),
        convId: this.ch1ActiveConv.id,
        senderId: this.ch1MyId,
        text: '',
        fileUrl: objectUrl,
        fileName: file.name,
        fileSize: this._ch1FormatBytes(file.size),
        createdAt: new Date().toISOString()
      };
      this.ch1Messages.push(msg);
      this._ch1UpdateConvPreview(this.ch1ActiveConv.id, { ...msg, text: '[File: ' + file.name + ']' });
      // Reset input
      e.target.value = '';
      this.ch1ShowToast('File attached (local preview)', '#10b981');
    },

    _ch1FormatBytes(bytes) {
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    },

    // ══════════════════════════════════════════
    // VOICE RECORDING
    // ══════════════════════════════════════════
    async ch1ToggleRecording() {
      if (this.ch1IsRecording) {
        this._ch1StopRecording();
      } else {
        await this._ch1StartRecording();
      }
    },

    async _ch1StartRecording() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        this.ch1RecordChunks = [];
        this.ch1MediaRecorder = new MediaRecorder(stream);
        this.ch1MediaRecorder.ondataavailable = (e) => { if (e.data.size > 0) this.ch1RecordChunks.push(e.data); };
        this.ch1MediaRecorder.onstop = () => this._ch1FinalizeVoice(stream);
        this.ch1MediaRecorder.start();
        this.ch1IsRecording = true;
        this.ch1ShowToast('Recording…', '#ef4444');
      } catch (err) {
        this.ch1ShowToast('Microphone not available', '#ef4444');
      }
    },

    _ch1StopRecording() {
      if (this.ch1MediaRecorder) this.ch1MediaRecorder.stop();
      this.ch1IsRecording = false;
    },

    _ch1FinalizeVoice(stream) {
      stream.getTracks().forEach(t => t.stop());
      if (!this.ch1ActiveConv || !this.ch1RecordChunks.length) return;
      const blob = new Blob(this.ch1RecordChunks, { type: 'audio/webm' });
      const url = URL.createObjectURL(blob);
      const msg = {
        id: 'voice_' + Date.now(),
        convId: this.ch1ActiveConv.id,
        senderId: this.ch1MyId,
        text: '',
        isVoice: true,
        fileUrl: url,
        duration: '0:' + String(Math.floor(blob.size / 8000)).padStart(2,'0'),
        createdAt: new Date().toISOString()
      };
      this.ch1Messages.push(msg);
      this._ch1UpdateConvPreview(this.ch1ActiveConv.id, { ...msg, text: '[Voice message]' });
      this.ch1ShowToast('Voice message sent', '#6366f1');
    },

    ch1PlayVoice(msg) {
      if (!msg.fileUrl) return;
      const audio = new Audio(msg.fileUrl);
      audio.play().catch(() => {});
    },

    // ══════════════════════════════════════════
    // TRANSFER / VIKI FLOW
    // ══════════════════════════════════════════
    _ch1HandleTransferRequest(data) {
      const tr = {
        id: data.id || 'tr_' + Date.now(),
        clientName: data.client_name || data.clientName || 'Unknown Client',
        country: data.country || '',
        countryFlag: this._ch1CountryFlag(data.country_code || data.country),
        campaign: data.campaign || '',
        arrivedAt: data.arrived_at || new Date().toISOString(),
        raw: data
      };
      this.ch1PendingTransfers.push(tr);
      this._ch1AddNotification('transfer', `Live transfer: ${tr.countryFlag} ${tr.clientName} from ${tr.country}`);
      // Open Viki panel
      this.c1SlideOpen = 'viki';
      this.ch1ShowToast(`Transfer request: ${tr.clientName}`, '#f59e0b');
    },

    ch1AcceptTransfer(tr) {
      this.ch1PendingTransfers = this.ch1PendingTransfers.filter(t => t.id !== tr.id);
      if (this.socket && this.socket.connected) {
        this.socket.emit('transfer:accept', { transferId: tr.id, agentId: this.ch1MyId });
      }
      this._ch1AddNotification('success', `Accepted transfer: ${tr.clientName}`);
      this.ch1ShowToast(`Transfer accepted — ${tr.clientName}`, '#10b981');
      this.c1SlideOpen = null;
      // Open a DM with client or special transfer thread
      const conv = {
        id: 'transfer_' + tr.id,
        type: 'direct',
        name: tr.clientName + ' [Transfer]',
        peerId: tr.raw.client_id || null,
        lastMsg: 'Transfer started', lastAt: Date.now(), unreadCount: 0
      };
      this.ch1Conversations.unshift(conv);
      this.ch1SelectConv(conv);
    },

    ch1DeclineTransfer(tr) {
      this.ch1PendingTransfers = this.ch1PendingTransfers.filter(t => t.id !== tr.id);
      if (this.socket && this.socket.connected) {
        this.socket.emit('transfer:decline', { transferId: tr.id, agentId: this.ch1MyId });
      }
      this._ch1AddNotification('warning', `Declined transfer: ${tr.clientName}`);
      this.ch1ShowToast(`Transfer declined`, '#ef4444');
    },

    ch1AskVPSales(tr) {
      this.ch1PendingTransfers = this.ch1PendingTransfers.filter(t => t.id !== tr.id);
      this.ch1VPTransferMode = tr;
      // Load agent scores
      this._ch1LoadAgentScores();
      if (this.socket && this.socket.connected) {
        this.socket.emit('transfer:ask_vp', { transferId: tr.id });
      }
      this._ch1AddNotification('info', `Sent to VP Sales: ${tr.clientName}`);
    },

    ch1AssignTransferToAgent(tr, agent) {
      if (this.socket && this.socket.connected) {
        this.socket.emit('transfer:assign', { transferId: tr.id, agentId: agent.id });
      }
      this.ch1VPTransferMode = null;
      this._ch1AddNotification('success', `Assigned ${tr.clientName} to ${agent.first_name}`);
      this.ch1ShowToast(`Assigned to ${agent.first_name} ${agent.last_name}`, '#10b981');
    },

    ch1YouDecide(tr) {
      if (this.socket && this.socket.connected) {
        this.socket.emit('transfer:you_decide', { transferId: tr.id });
      }
      this.ch1VPTransferMode = null;
      this._ch1AddNotification('info', `Auto-assign requested for ${tr.clientName}`);
      this.ch1ShowToast('Auto-assign requested', '#6366f1');
    },

    _ch1LoadAgentScores() {
      // Try API first, fall back to mock
      fetch(API + '/agents/scores', { headers: apiHeaders() })
        .then(r => r.json())
        .then(data => { this.ch1AgentScores = data.agents || data || []; })
        .catch(() => {
          this.ch1AgentScores = this.ch1AllUsers.map(u => ({
            ...u,
            score: Math.floor(60 + Math.random() * 40),
            transfers_today: Math.floor(Math.random() * 5),
            deposits_today: Math.floor(Math.random() * 3)
          }));
        });
    },

    ch1ScoreColor(score) {
      if (score >= 85) return '#10b981';
      if (score >= 60) return '#f59e0b';
      return '#ef4444';
    },

    _ch1CountryFlag(country) {
      const map = { ZA:'🇿🇦', UK:'🇬🇧', GB:'🇬🇧', US:'🇺🇸', DE:'🇩🇪', FR:'🇫🇷', AU:'🇦🇺', CA:'🇨🇦', NL:'🇳🇱', IL:'🇮🇱' };
      if (!country) return '🌍';
      const code = country.toUpperCase().slice(0,2);
      return map[code] || '🌍';
    },

    _ch1AddNotification(type, text) {
      this.ch1Notifications.unshift({ type, text, ts: new Date().toISOString() });
      if (this.ch1Notifications.length > 50) this.ch1Notifications = this.ch1Notifications.slice(0, 50);
    },

    // ══════════════════════════════════════════
    // AGENT STATS
    // ══════════════════════════════════════════
    _ch1FetchAgentStats() {
      fetch(API + '/agents/stats/today', { headers: apiHeaders() })
        .then(r => r.json())
        .then(data => {
          this.ch1AgentStats = {
            scheduledCalls: data.scheduled_calls || data.scheduledCalls || 0,
            leads: data.leads || 0,
            deposits: data.deposits || 0,
            naAmount: data.na_amount || data.naAmount || 0,
            transfers: data.transfers || 0,
            referrals: data.referrals || 0,
            registrations: data.registrations || 0,
            assigned: data.assigned || 0
          };
        })
        .catch(() => {
          // Seed mock stats
          this.ch1AgentStats = { scheduledCalls:4, leads:12, deposits:3, naAmount:7, transfers:2, referrals:5, registrations:8, assigned:11 };
        });
    },

    // ══════════════════════════════════════════
    // SCROLL
    // ══════════════════════════════════════════
    ch1ScrollToBottom(smooth) {
      const el = this.$refs.msgBottom;
      if (el) el.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'end' });
    },

    ch1OnMsgScroll() {
      // Future: load older messages on scroll to top
    },

    // ══════════════════════════════════════════
    // CALENDAR
    // ══════════════════════════════════════════
    ch1CalPrev() {
      if (this.ch1Cal.month === 0) { this.ch1Cal.month = 11; this.ch1Cal.year--; }
      else this.ch1Cal.month--;
    },
    ch1CalNext() {
      if (this.ch1Cal.month === 11) { this.ch1Cal.month = 0; this.ch1Cal.year++; }
      else this.ch1Cal.month++;
    },
    ch1JumpToDate(dateStr) {
      this.ch1Cal.selected = dateStr;
      this.c1SlideOpen = null;
      if (!this.ch1ActiveConv) return;
      this.$nextTick(() => {
        const refs = this.$refs['datesep_' + dateStr];
        const el = refs && refs[0];
        if (el) el.scrollIntoView({ behavior:'smooth', block:'start' });
      });
    },

    // ══════════════════════════════════════════
    // PANEL HELPERS
    // ══════════════════════════════════════════
    c1OpenSlide(name) { this.c1SlideOpen = this.c1SlideOpen === name ? null : name; },
    ch1SlideOpen_close() { this.c1SlideOpen = null; },
    ch1SetDate(preset) { this.ch1Filter.date = preset; this.c1SlideOpen = null; },
    ch1ToggleOnline() {
      this.ch1UserOnline = !this.ch1UserOnline;
      if (this.socket && this.socket.connected) this.socket.emit('chat:status', { online: this.ch1UserOnline });
    },

    // ══════════════════════════════════════════
    // TOAST
    // ══════════════════════════════════════════
    ch1ShowToast(msg, color) {
      clearTimeout(this._ch1ToastTimer);
      this.ch1Toast = { msg, color: color || '#6366f1' };
      this._ch1ToastTimer = setTimeout(() => { this.ch1Toast = null; }, 3000);
    },

    // ══════════════════════════════════════════
    // DISPLAY HELPERS
    // ══════════════════════════════════════════
    ch1PersonInitials(user) {
      return ((user.first_name||'')[0]||'').toUpperCase() + ((user.last_name||'')[0]||'').toUpperCase() || '?';
    },
    ch1PersonShortName(user) { return user.first_name || user.username || '?'; },
    ch1UserColor(user) {
      const id = user.id || 0;
      return this.ch1AvatarColors[id % this.ch1AvatarColors.length];
    },
    ch1RoomColor(room) { return room.color || '#6366f1'; },
    ch1RoomInitials(room) { return (room.name||'?')[0].toUpperCase(); },
    ch1ConvInitials(conv) {
      if (!conv) return '?';
      if (conv.type === 'room') return '#';
      return (conv.name||'?').split(' ').map(w => w[0]).join('').toUpperCase().slice(0,2);
    },
    ch1ConvColor(conv) {
      if (!conv) return '#6366f1';
      if (conv.type === 'room') {
        const room = this.ch1AllRooms.find(r => r.id === conv.roomId);
        return room ? room.color : '#6366f1';
      }
      const peer = this.ch1AllUsers.find(u => u.id === conv.peerId);
      if (peer) return this.ch1UserColor(peer);
      return this.ch1AvatarColors[(conv.id||'').length % this.ch1AvatarColors.length];
    },
    ch1IsOnline(userId) { return userId && this.ch1OnlineUserIds.includes(userId); },
    ch1SenderColor(senderId) {
      const user = this.ch1AllUsers.find(u => u.id === senderId);
      if (user) return this.ch1UserColor(user);
      return this.ch1AvatarColors[(senderId||0) % this.ch1AvatarColors.length];
    },
    ch1SenderInitials(senderId) {
      const user = this.ch1AllUsers.find(u => u.id === senderId);
      return user ? this.ch1PersonInitials(user) : '?';
    },
    ch1SenderName(senderId) {
      const user = this.ch1AllUsers.find(u => u.id === senderId);
      return user ? (user.first_name || 'Unknown') : 'Unknown';
    },

    // ══════════════════════════════════════════
    // FORMATTING
    // ══════════════════════════════════════════
    ch1FmtTime(ts) {
      if (!ts) return '';
      const d = new Date(ts);
      if (isNaN(d)) return '';
      const now = new Date();
      const todayStr = this._ch1DateStr(now);
      const dStr = this._ch1DateStr(d);
      if (dStr === todayStr) return d.toLocaleTimeString('en-GB', { hour:'2-digit', minute:'2-digit' });
      const yesterday = new Date(now); yesterday.setDate(yesterday.getDate() - 1);
      if (dStr === this._ch1DateStr(yesterday)) return 'Yesterday';
      return d.toLocaleDateString('en-GB', { day:'2-digit', month:'short' });
    },
    ch1FmtMsgTime(ts) {
      if (!ts) return '';
      const d = new Date(ts);
      if (isNaN(d)) return '';
      return d.toLocaleTimeString('en-GB', { hour:'2-digit', minute:'2-digit' });
    },
    ch1FmtDateSep(dateStr) {
      if (!dateStr || dateStr === 'unknown') return '';
      const d = new Date(dateStr);
      if (isNaN(d)) return dateStr;
      const today = this._ch1DateStr(new Date());
      const yesterday = new Date(); yesterday.setDate(yesterday.getDate() - 1);
      if (dateStr === today) return 'Today';
      if (dateStr === this._ch1DateStr(yesterday)) return 'Yesterday';
      return d.toLocaleDateString('en-GB', { weekday:'long', day:'numeric', month:'long' });
    },
    _ch1DateStr(d) { return d.toISOString().slice(0,10); },

    // ══════════════════════════════════════════
    // INTERNAL HELPERS
    // ══════════════════════════════════════════
    _ch1UpdateConvPreview(convId, msg) {
      const conv = this.ch1Conversations.find(c => c.id === convId);
      if (conv) {
        conv.lastMsg = msg.text ? (msg.text.length > 60 ? msg.text.slice(0,60)+'…' : msg.text) : '';
        conv.lastAt = msg.createdAt ? new Date(msg.createdAt).getTime() : Date.now();
      }
    },
    _ch1IncrUnread(convId) {
      const conv = this.ch1Conversations.find(c => c.id === convId);
      if (conv) conv.unreadCount = (conv.unreadCount || 0) + 1;
    },
    _ch1LoadUsers() {
      const salesList = this.$store.state.clients && this.$store.state.clients.salesPersonList;
      if (salesList && salesList.length) {
        this.ch1AllUsers = salesList.map(u => ({
          id: u.id,
          first_name: u.first_name || (u.full_name||'').split(' ')[0] || u.username || '?',
          last_name: u.last_name || (u.full_name||'').split(' ').slice(1).join(' ') || ''
        }));
      } else {
        this.ch1AllUsers = [
          { id: 1001, first_name: 'Alex',  last_name: 'Carter' },
          { id: 1002, first_name: 'Maya',  last_name: 'Singh' },
          { id: 1003, first_name: 'James', last_name: "O'Brien" },
          { id: 1004, first_name: 'Sofia', last_name: 'Lee' },
          { id: 1005, first_name: 'David', last_name: 'Cohen' }
        ];
      }
    },
    _ch1FetchShifts() {
      const today = new Date().toISOString().slice(0, 10);
      fetch(API + '/shifts/all_users_shifts_for_today/' + today, { headers: apiHeaders() })
        .then(r => r.json())
        .then(data => {
          const list = Array.isArray(data) ? data : (data.shifts || data.data || []);
          const now = Date.now();
          this.ch1UsersOnShift = list
            .filter(s => {
              if (!s.start_time || !s.end_time) return !!s.user_id;
              const start = new Date(s.start_time).getTime();
              const end   = new Date(s.end_time).getTime();
              return now >= start && now <= end;
            })
            .map(s => s.user_id || s.id);
        })
        .catch(() => {});
    },
    ch1IsOnShift(userId) {
      return userId && this.ch1UsersOnShift.includes(userId);
    },

    // ══════════════════════════════════════════
    // TEAM CHANNELS
    // ══════════════════════════════════════════
    _ch1FetchTeams() {
      fetch(API + '/admin/teams', { headers: apiHeaders() })
        .then(r => r.json())
        .then(data => {
          this.ch1TeamsInfo = Array.isArray(data) ? data : (data.data || data.teams || []);
        })
        .catch(() => {
          // Fallback: provide static team definitions so UI renders even without endpoint
          this.ch1TeamsInfo = [
            { id: 1, name: 'Team 1', emoji: '⚡', color: '#0e7490', member_count: 0 },
            { id: 2, name: 'Team 2', emoji: '🔥', color: '#7c3aed', member_count: 0 }
          ];
        });
    },

    ch1SelectTeamChannel(channelId) {
      this.ch1TeamChannel = channelId;
      this.ch1ActiveConv = null;
      this.ch1Messages = [];
      this.ch1LoadingMessages = true;
      // Build a synthetic conv object so the right panel renders
      const teamDef = channelId === 'team_1'
        ? { id: 'team_1', type: 'team', name: '⚡ Team 1', color: '#0e7490', teamId: 1 }
        : { id: 'team_2', type: 'team', name: '🔥 Team 2', color: '#7c3aed', teamId: 2 };
      this.ch1ActiveConv = teamDef;
      if (this.socket && this.socket.connected) {
        this.socket.emit('chat:join', { convId: channelId });
        this.socket.emit('chat:get_history', { convId: channelId, limit: 80 });
      } else {
        this.ch1LoadingMessages = false;
      }
      clearTimeout(this._ch1LoadTimeout);
      this._ch1LoadTimeout = setTimeout(() => {
        if (this.ch1LoadingMessages) this.ch1LoadingMessages = false;
      }, 5000);
    },

    ch1MyTeamId() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      return u ? (u.team_id || null) : null;
    },

    ch1TeamChannelDefs() {
      const myTeamId = this.ch1MyTeamId();
      return [
        {
          channelId: 'team_1', teamId: 1, label: '⚡ Team 1', color: '#0e7490',
          locked: myTeamId !== null && myTeamId !== 1,
          memberCount: (() => {
            const t = this.ch1TeamsInfo.find(x => x.id === 1);
            return t ? (t.member_count || t.members_count || 0) : 0;
          })()
        },
        {
          channelId: 'team_2', teamId: 2, label: '🔥 Team 2', color: '#7c3aed',
          locked: myTeamId !== null && myTeamId !== 2,
          memberCount: (() => {
            const t = this.ch1TeamsInfo.find(x => x.id === 2);
            return t ? (t.member_count || t.members_count || 0) : 0;
          })()
        }
      ];
    },

    _ch1SeedMock() {
      const now = Date.now();
      this.ch1Conversations = [
        { id:'room_general', type:'room', name:'# General', roomId:'room_general', lastMsg:'Morning everyone', lastAt:now-5*60*1000, unreadCount:3 },
        { id:'room_sales', type:'room', name:'# Sales', roomId:'room_sales', lastMsg:'Closed 2 deposits today', lastAt:now-22*60*1000, unreadCount:0 },
        { id:'room_support', type:'room', name:'# Support', roomId:'room_support', lastMsg:'Client issue resolved', lastAt:now-60*60*1000, unreadCount:1 },
        { id:'direct_me_1001', type:'direct', name:'Alex Carter', peerId:1001, lastMsg:'Can you check the new client?', lastAt:now-45*60*1000, unreadCount:1 },
        { id:'direct_me_1002', type:'direct', name:'Maya Singh', peerId:1002, lastMsg:'Report is ready', lastAt:now-2*60*60*1000, unreadCount:0 },
        { id:'direct_me_1003', type:'direct', name:"James O'Brien", peerId:1003, lastMsg:'Transfer approved', lastAt:now-3*60*60*1000, unreadCount:0 }
      ];
      this.ch1OnlineUserIds = [1001, 1003, 1005];
    },
    _ch1SeedMockTransfers() {
      // Simulate an incoming transfer after 3 seconds in mock mode
      if (!io) {
        setTimeout(() => {
          this._ch1HandleTransferRequest({
            id: 'mock_tr_1',
            client_name: 'Robert Williamson',
            country: 'South Africa',
            country_code: 'ZA',
            campaign: 'Crypto_ZA_Q2',
            arrived_at: new Date().toISOString(),
            client_id: 9901
          });
        }, 3000);
      }
    },
    _ch1LoadMockMessages(convId) {
      setTimeout(() => {
        const base = new Date();
        const otherId = 1001;
        const myId = this.ch1MyId || 0;
        const samples = [
          { senderId: otherId, text:'Hey, are you free for a quick call?', offsetMin:35 },
          { senderId: myId, text:'Sure, give me 5 minutes.', offsetMin:33 },
          { senderId: otherId, text:'New client came in from the UK campaign.', offsetMin:30 },
          { senderId: myId, text:'I saw that — assigned it already.', offsetMin:29 },
          { senderId: otherId, text:'Perfect. What status did you set?', offsetMin:28 },
          { senderId: myId, text:'Scheduled call for tomorrow 10am.', offsetMin:25 },
          { senderId: otherId, text:'Great. Let me know how it goes.', offsetMin:10 },
          { senderId: otherId, text:'Also check the finance report when you get a chance.', offsetMin:5 },
          { senderId: myId, text:'Will do.', offsetMin:4 }
        ];
        this.ch1Messages = samples.map(s => ({
          id: 'mock_' + Math.random().toString(36).slice(2),
          convId,
          senderId: s.senderId,
          text: s.text,
          createdAt: new Date(base.getTime() - s.offsetMin * 60 * 1000).toISOString()
        }));
        this.ch1LoadingMessages = false;
      }, 400);
    }
  }
};
</script>

<style scoped>
/* ═══════════════════════════════════════════════════
   LIGHT THEME — Chat1 design system
   bg #f4f3f0  surface #ffffff  border #e4e3df  accent #6366f1
═══════════════════════════════════════════════════ */
.ch1-main {
  --c1-bg:      #f7f8fa;
  --c1-surface: #ffffff;
  --c1-surface2: #f0f2f5;
  --c1-border:  #e3e8ee;
  --c1-text:    #111827;
  --c1-muted:   #6b7280;
  --c1-accent:  #6366f1;
  --c1-accent2: #8b5cf6;
  --c1-dp:      #22c55e;
  --c1-ld:      #f59e0b;
  --c1-na:      #ef4444;
  --c1-sc:      #3b82f6;
  --c1-rf:      #a855f7;
  --c1-ni:      #6b7280;
  --ch1-bg:     var(--c1-bg);
  --ch1-surf:   var(--c1-surface);
  --ch1-surf2:  var(--c1-surface2);
  --ch1-brd:    var(--c1-border);
  --ch1-brd2:   #e3e8ee;
  --ch1-ac:     var(--c1-accent);
  --ch1-ac-dim: rgba(99,102,241,.10);
  --ch1-ac-glow:rgba(99,102,241,.2);
  --ch1-t1:     var(--c1-text);
  --ch1-t2:     #6b7280;
  --ch1-t3:     #9ca3af;
  --ch1-online: #10b981;
  --ch1-radius: 12px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: 'DM Sans', -apple-system, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 13px;
  position: relative;
  overflow: hidden;
}

.c1-hp { flex: 1; }

/* ═══ TOAST ═══ */
.ch1-toast {
  position: fixed; bottom: 28px; left: 50%; transform: translateX(-50%);
  z-index: 99999; padding: 10px 22px; border-radius: 24px; color: #fff; font-size: .85rem; font-weight: 600;
  box-shadow: 0 4px 20px rgba(0,0,0,.25); pointer-events: none; white-space: nowrap;
  height: auto; display: inline-flex; align-items: center;
}
.ch1-toast-fade-enter-active, .ch1-toast-fade-leave-active { transition: opacity .25s, transform .25s; }
.ch1-toast-fade-enter, .ch1-toast-fade-leave-to { opacity: 0; transform: translateX(-50%) translateY(10px); }

/* ═══ TOP BAR ═══ */
.ch1-tib {
  display: flex; align-items: center; gap: 2px;
  padding: 0 10px; height: 48px;
  background: var(--ch1-surf);
  border-bottom: 1px solid var(--ch1-brd);
  flex-shrink: 0; position: sticky; top: 0; z-index: 150;
}
.ch1-tib .c1-tib-btn {
  display: flex; flex-direction: column; align-items: center; gap: 2px;
  padding: 5px 10px; border-radius: 8px; cursor: pointer;
  color: var(--ch1-t2); font-size: 9px; font-weight: 600;
  letter-spacing: .3px; text-transform: uppercase;
  transition: background .15s, color .15s; position: relative;
}
.ch1-tib .c1-tib-btn svg {
  width: 15px; height: 15px; stroke: currentColor; fill: none;
  stroke-width: 2; stroke-linecap: round; stroke-linejoin: round;
}
.ch1-tib .c1-tib-btn:hover  { background: rgba(0,0,0,.05); color: var(--ch1-t1); }
.ch1-tib .c1-tib-btn.on     { background: var(--ch1-ac-dim); color: var(--ch1-ac); }
.ch1-tib .c1-tib-btn.on svg { stroke: var(--ch1-ac); }

/* Viki badge */
.ch1-viki-badge {
  position: absolute; top: 3px; right: 3px;
  width: 14px; height: 14px; border-radius: 50%;
  background: #ef4444; color: #fff;
  font-size: 8px; font-weight: 700;
  display: flex; align-items: center; justify-content: center;
}

/* Connection dot */
.ch1-conn-dot {
  width: 8px; height: 8px; border-radius: 50%;
  background: var(--ch1-t3); flex-shrink: 0; transition: background .3s;
}
.ch1-conn-dot.connected    { background: var(--ch1-online); }
.ch1-conn-dot.connecting   { background: #f59e0b; animation: ch1blink 1s infinite; }
.ch1-conn-dot.disconnected { background: #ef4444; }

/* User avatar in top bar */
.ch1-tib .c1-tib-user {
  width: 32px; height: 32px; border-radius: 50%;
  background: var(--ch1-ac);
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; transition: opacity .15s; flex-shrink: 0; position: relative;
}
.ch1-tib .c1-tib-user.on { box-shadow: 0 0 0 2px var(--ch1-ac); }
.ch1-tib .c1-tib-ini { font-size: 11px; font-weight: 700; color: #fff; letter-spacing: -.3px; }
.ch1-tib .c1-tib-udot {
  position: absolute; bottom: 0; right: 0;
  width: 9px; height: 9px; border-radius: 50%;
  border: 2px solid var(--ch1-surf); background: var(--ch1-t3);
}
.ch1-tib .c1-tib-udot.online { background: var(--ch1-online); }

/* ═══ SLIDE PANELS ═══ */
.ch1-panel {
  background: var(--ch1-surf); border-bottom: 1px solid var(--ch1-brd);
  flex-shrink: 0; max-height: 0; overflow: hidden;
  -webkit-overflow-scrolling: touch;
  transition: max-height .25s cubic-bezier(.4,0,.2,1);
}
.ch1-panel.c1-panel--open {
  max-height: 75vh; overflow-y: auto;
}
.ch1-panel .c1-sl-body { padding: 14px; }
.ch1-panel .c1-fp-group { margin-bottom: 14px; }
.ch1-panel .c1-fp-lbl {
  font-size: 9px; font-weight: 700; text-transform: uppercase;
  letter-spacing: .5px; color: var(--ch1-t2); margin-bottom: 7px;
}
.ch1-panel .c1-fp-opts { display: flex; flex-wrap: wrap; gap: 6px; }
.ch1-panel .c1-fp-opt {
  padding: 5px 11px; border-radius: 20px;
  border: 1px solid var(--ch1-brd2);
  background: var(--ch1-surf2); color: var(--ch1-t2);
  font-size: 11px; font-weight: 600; cursor: pointer; transition: all .12s;
}
.ch1-panel .c1-fp-opt:hover { border-color: var(--ch1-ac); color: var(--ch1-t1); }
.ch1-panel .c1-fp-opt.on    { background: var(--ch1-ac-dim); border-color: var(--ch1-ac); color: var(--ch1-ac); }
.ch1-panel .c1-agent-grid { display: flex; flex-wrap: wrap; gap: 7px; }
.ch1-panel .c1-agent-chip {
  display: flex; align-items: center; gap: 6px;
  padding: 5px 10px 5px 5px;
  background: var(--ch1-surf2); border-radius: 20px;
  border: 1px solid var(--ch1-brd2); cursor: pointer; transition: all .12s;
}
.ch1-panel .c1-agent-chip:hover { border-color: var(--ch1-ac); }
.ch1-panel .c1-agent-chip.on    { background: var(--ch1-ac-dim); border-color: var(--ch1-ac); }
.ch1-panel .c1-agent-av {
  width: 22px; height: 22px; border-radius: 50%;
  display: grid; place-items: center;
  font-size: 9px; font-weight: 700; color: #fff; flex-shrink: 0;
}
.ch1-panel .c1-agent-nm { font-size: 11px; font-weight: 600; color: var(--ch1-t1); }

/* Room chips */
.ch1-room-list { display: flex; flex-wrap: wrap; gap: 7px; }
.ch1-room-chip {
  display: flex; align-items: center; gap: 7px;
  padding: 6px 12px 6px 6px;
  background: var(--ch1-surf2); border-radius: 20px;
  border: 1px solid var(--ch1-brd2); cursor: pointer; transition: all .12s;
}
.ch1-room-chip:hover { border-color: var(--ch1-ac); }
.ch1-room-chip.on    { background: var(--ch1-ac-dim); border-color: var(--ch1-ac); }
.ch1-room-av {
  width: 22px; height: 22px; border-radius: 6px;
  display: grid; place-items: center;
  font-size: 11px; font-weight: 700; color: #fff; flex-shrink: 0;
}
.ch1-room-nm { font-size: 12px; font-weight: 600; color: var(--ch1-t1); }

/* Collapse bar */
.ch1-collapse-bar {
  display: flex; align-items: center; justify-content: center; gap: 6px;
  padding: 10px 16px; border-top: 1px solid var(--ch1-brd);
  background: var(--ch1-surf2); cursor: pointer;
  font-size: 11px; font-weight: 600; color: var(--ch1-t2);
  transition: background .12s, color .12s; flex-shrink: 0;
}
.ch1-collapse-bar svg { width: 14px; height: 14px; stroke: currentColor; fill: none; stroke-width: 2; }
.ch1-collapse-bar:hover { background: var(--ch1-brd); color: var(--ch1-t1); }

/* ═══ CALENDAR ═══ */
.ch1-cal-nav {
  display: flex; align-items: center; justify-content: space-between;
  padding: 0 14px 10px;
}
.ch1-cal-nav-btn {
  background: none; border: none; cursor: pointer;
  color: var(--ch1-t2); padding: 4px; transition: color .12s;
}
.ch1-cal-nav-btn:hover { color: var(--ch1-t1); }
.ch1-cal-nav-btn svg { width: 16px; height: 16px; stroke: currentColor; fill: none; stroke-width: 2; }
.ch1-cal-month-lbl { font-size: 13px; font-weight: 700; color: var(--ch1-t1); }
.ch1-cal-grid { display: grid; grid-template-columns: repeat(7, 1fr); gap: 3px; padding: 0 14px 14px; }
.ch1-cal-dow {
  text-align: center; font-size: 9px; font-weight: 700;
  color: var(--ch1-t3); text-transform: uppercase; padding: 2px 0;
}
.ch1-cal-cell {
  position: relative; text-align: center; padding: 6px 0;
  font-size: 12px; font-weight: 500; color: var(--ch1-t1);
  border-radius: 8px; cursor: pointer; transition: background .12s;
}
.ch1-cal-cell:hover { background: var(--ch1-surf2); }
.ch1-cal-cell.ch1-cal-other { color: var(--ch1-t3); cursor: default; }
.ch1-cal-cell.ch1-cal-other:hover { background: none; }
.ch1-cal-cell.ch1-cal-today { background: var(--ch1-ac-dim); color: var(--ch1-ac); font-weight: 700; }
.ch1-cal-cell.ch1-cal-active { background: var(--ch1-ac); color: #fff; font-weight: 700; }
.ch1-cal-dot {
  position: absolute; bottom: 2px; left: 50%; transform: translateX(-50%);
  width: 4px; height: 4px; border-radius: 50%; background: var(--ch1-ac);
}
.ch1-cal-cell.ch1-cal-active .ch1-cal-dot { background: rgba(255,255,255,.7); }

/* ═══ VIKI PANEL ═══ */
.ch1-viki-panel { max-height: 80vh; }
.ch1-viki-head {
  display: flex; align-items: center; justify-content: space-between;
  padding: 14px 16px 10px;
  border-bottom: 1px solid var(--ch1-brd);
}
.ch1-viki-title { display: flex; align-items: center; gap: 10px; }
.ch1-viki-av {
  width: 36px; height: 36px; border-radius: 50%;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  display: grid; place-items: center;
  font-size: 14px; font-weight: 800; color: #fff;
  box-shadow: 0 0 12px rgba(99,102,241,.4);
}
.ch1-viki-name { font-size: 14px; font-weight: 700; color: var(--ch1-t1); }
.ch1-viki-sub { font-size: 10px; color: var(--ch1-t3); margin-top: 1px; }
.ch1-viki-status-dot {
  width: 10px; height: 10px; border-radius: 50%;
  background: var(--ch1-t3);
}
.ch1-viki-status-dot.active { background: var(--ch1-online); animation: ch1pulse 2s infinite; }

.ch1-viki-section { padding: 12px 14px; border-bottom: 1px solid var(--ch1-brd); }
.ch1-viki-section-lbl {
  font-size: 9px; font-weight: 700; text-transform: uppercase;
  letter-spacing: .5px; color: var(--ch1-t3); margin-bottom: 10px;
  display: flex; align-items: center; gap: 6px;
}
.ch1-viki-badge-inline {
  background: #ef4444; color: #fff;
  font-size: 9px; font-weight: 700;
  padding: 1px 6px; border-radius: 10px;
}
.ch1-viki-empty { font-size: 11px; color: var(--ch1-t3); font-style: italic; }

/* Transfer cards */
.ch1-transfer-card {
  display: flex; align-items: center; gap: 10px;
  padding: 10px 12px; border-radius: 10px;
  background: rgba(239,68,68,.08);
  border: 1px solid rgba(239,68,68,.25);
  margin-bottom: 8px;
  animation: ch1slideIn .3s ease;
}
@keyframes ch1slideIn {
  from { opacity: 0; transform: translateY(-6px); }
  to   { opacity: 1; transform: translateY(0); }
}
.ch1-transfer-flag { font-size: 22px; flex-shrink: 0; }
.ch1-transfer-info { flex: 1; min-width: 0; }
.ch1-transfer-name { font-size: 13px; font-weight: 600; color: var(--ch1-t1); }
.ch1-transfer-meta { font-size: 10px; color: var(--ch1-t2); margin-top: 2px; }
.ch1-transfer-actions { display: flex; gap: 5px; flex-shrink: 0; flex-wrap: wrap; }
.ch1-tr-btn {
  padding: 5px 10px; border-radius: 6px; border: none;
  font-size: 10px; font-weight: 700; cursor: pointer;
  transition: opacity .12s; white-space: nowrap;
}
.ch1-tr-accept  { background: #10b981; color: #fff; }
.ch1-tr-decline { background: rgba(239,68,68,.2); color: #fca5a5; }
.ch1-tr-vp      { background: rgba(99,102,241,.2); color: #a5b4fc; }
.ch1-tr-btn:hover { opacity: .8; }

/* VP Transfer mode */
.ch1-vp-transfer-wrap { padding: 4px 0; }
.ch1-vp-transfer-client { font-size: 12px; color: var(--ch1-t1); margin-bottom: 10px; }
.ch1-agent-score-list { display: flex; flex-direction: column; gap: 6px; margin-bottom: 10px; }
.ch1-agent-score-row {
  display: flex; align-items: center; gap: 9px;
  padding: 8px 10px; border-radius: 8px;
  background: var(--ch1-surf2); border: 1px solid var(--ch1-brd2);
  cursor: pointer; transition: border-color .12s;
}
.ch1-agent-score-row:hover { border-color: var(--ch1-ac); }
.ch1-agent-score-av {
  width: 28px; height: 28px; border-radius: 50%;
  display: grid; place-items: center;
  font-size: 10px; font-weight: 700; color: #fff; flex-shrink: 0;
}
.ch1-agent-score-info { flex: 1; min-width: 0; }
.ch1-agent-score-name { font-size: 12px; font-weight: 600; color: var(--ch1-t1); }
.ch1-agent-score-meta { display: flex; align-items: center; gap: 6px; margin-top: 3px; }
.ch1-score-pill {
  padding: 1px 6px; border-radius: 8px;
  font-size: 9px; font-weight: 700; color: #fff;
}
.ch1-score-meta-item { font-size: 10px; color: var(--ch1-t2); }
.ch1-score-online { font-size: 9px; color: var(--ch1-online); font-weight: 600; }
.ch1-vp-you-decide, .ch1-vp-cancel {
  width: 100%; padding: 8px; border-radius: 8px; border: none;
  font-size: 12px; font-weight: 600; cursor: pointer; margin-top: 5px;
}
.ch1-vp-you-decide { background: var(--ch1-ac); color: #fff; }
.ch1-vp-cancel     { background: var(--ch1-surf2); color: var(--ch1-t2); }

/* Viki agents list */
.ch1-viki-agents { display: flex; flex-direction: column; gap: 6px; }
.ch1-viki-agent-row {
  display: flex; align-items: center; gap: 9px;
  padding: 7px 8px; border-radius: 8px; cursor: pointer;
  transition: background .12s;
}
.ch1-viki-agent-row:hover { background: var(--ch1-surf2); }
.ch1-viki-agent-av {
  width: 28px; height: 28px; border-radius: 50%;
  display: grid; place-items: center;
  font-size: 10px; font-weight: 700; color: #fff; flex-shrink: 0;
}
.ch1-viki-agent-name { flex: 1; font-size: 12px; font-weight: 500; color: var(--ch1-t1); }
.ch1-viki-agent-dot {
  width: 8px; height: 8px; border-radius: 50%;
  background: var(--ch1-online); flex-shrink: 0;
  animation: ch1pulse 2s infinite;
}

/* Notifications */
.ch1-notif-row {
  display: flex; align-items: flex-start; gap: 8px;
  padding: 7px 0;
  border-bottom: 1px solid var(--ch1-brd);
}
.ch1-notif-row:last-child { border-bottom: none; }
.ch1-notif-dot {
  width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; margin-top: 3px;
}
.ch1-notif-transfer .ch1-notif-dot { background: #f59e0b; }
.ch1-notif-message  .ch1-notif-dot { background: var(--ch1-ac); }
.ch1-notif-success  .ch1-notif-dot { background: #10b981; }
.ch1-notif-warning  .ch1-notif-dot { background: #ef4444; }
.ch1-notif-info     .ch1-notif-dot { background: #06b6d4; }
.ch1-notif-body { flex: 1; min-width: 0; }
.ch1-notif-text { font-size: 11px; color: var(--ch1-t1); line-height: 1.4; }
.ch1-notif-time { font-size: 9px; color: var(--ch1-t3); margin-top: 2px; }

/* ═══ PROFILE PANEL ═══ */
.ch1-prof-panel {
  position: fixed; top: 48px; left: 0; right: 0; bottom: 0;
  background: var(--ch1-bg); z-index: 250;
  display: flex; flex-direction: column; overflow: hidden;
  transform: translateY(-100%); opacity: 0; pointer-events: none;
  transition: transform .25s cubic-bezier(.4,0,.2,1), opacity .25s;
}
.ch1-prof-panel.c1-panel--open {
  transform: translateY(0); opacity: 1; pointer-events: auto;
}
.ch1-prof-head { background: var(--ch1-surf); border-bottom: 1px solid var(--ch1-brd); flex-shrink: 0; }
.ch1-prof-brand-row { display: flex; align-items: center; padding: 12px 16px 8px; }
.ch1-prof-brand { font-size: 18px; font-weight: 800; color: var(--ch1-t1); letter-spacing: -.5px; }
.ch1-prof-brand span { color: var(--ch1-ac); }
.ch1-tz-row { display: flex; gap: 12px; }
.ch1-tz { display: flex; flex-direction: column; align-items: center; }
.ch1-tz-lbl { font-size: 8px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--ch1-t3); }
.ch1-tz-t { font-family: 'JetBrains Mono', monospace; font-size: 12px; font-weight: 700; color: var(--ch1-t1); }
.ch1-prof-user-row { display: flex; align-items: center; gap: 10px; padding: 8px 16px 14px; }
.ch1-prof-av {
  width: 42px; height: 42px; border-radius: 50%;
  background: var(--ch1-ac); display: grid; place-items: center;
  color: #fff; font-size: 15px; font-weight: 700; flex-shrink: 0;
}
.ch1-prof-meta { flex: 1; min-width: 0; }
.ch1-prof-name { font-size: 14px; font-weight: 600; color: var(--ch1-t1); }
.ch1-prof-role { font-size: 10px; color: var(--ch1-t2); margin-top: 2px; }
.ch1-prof-toggle {
  display: flex; align-items: center; gap: 5px;
  padding: 6px 12px; border-radius: 20px;
  border: 1px solid var(--ch1-brd2); cursor: pointer;
  font-size: 11px; font-weight: 600; color: var(--ch1-t2);
  transition: all .15s; white-space: nowrap;
}
.ch1-prof-toggle.online { border-color: var(--ch1-online); color: var(--ch1-online); background: rgba(16,185,129,.1); }
.ch1-tog-dot { width: 8px; height: 8px; border-radius: 50%; background: var(--ch1-t3); flex-shrink: 0; }
.ch1-prof-toggle.online .ch1-tog-dot { background: var(--ch1-online); animation: ch1pulse 2s infinite; }
.ch1-prof-scroll { flex: 1; overflow-y: auto; padding: 14px 14px 30px; -webkit-overflow-scrolling: touch; }

.ch1-prof-scroll .c1-nc-lbl {
  font-size: 9px; font-weight: 700; text-transform: uppercase;
  letter-spacing: .7px; color: var(--ch1-t3); margin: 16px 4px 8px;
}
.ch1-prof-scroll .c1-nc-lbl:first-child { margin-top: 2px; }
.ch1-prof-scroll .c1-ng { display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; }
.ch1-prof-scroll .c1-nb {
  display: flex; flex-direction: column; align-items: center;
  justify-content: center; gap: 7px; padding: 14px 6px 12px;
  border-radius: 12px; border: 1px solid transparent;
  cursor: pointer; text-decoration: none; transition: all .12s;
  color: var(--ch1-t2); background: var(--ch1-surf2);
}
.ch1-prof-scroll .c1-nb svg {
  width: 22px; height: 22px; stroke: currentColor; fill: none;
  stroke-width: 1.8; stroke-linecap: round; stroke-linejoin: round;
}
.ch1-prof-scroll .c1-nb span { font-size: 10px; font-weight: 600; text-align: center; color: inherit; }
.ch1-prof-scroll .c1-nb:active { transform: scale(.95); }
.ch1-prof-scroll .c1-nb-dp     { background: rgba(99,102,241,.12); color: #a5b4fc; }
.ch1-prof-scroll .c1-nb-dp:hover { border-color: var(--ch1-ac); }
.ch1-prof-scroll .c1-nb-sc     { background: rgba(245,158,11,.1); color: #fbbf24; }
.ch1-prof-scroll .c1-nb-na     { background: var(--ch1-surf2); color: var(--ch1-t2); }
.ch1-prof-scroll .c1-nb-logout { background: rgba(239,68,68,.1); color: #fca5a5; }
.ch1-prof-scroll .c1-nb-logout:hover { border-color: #ef4444; }
.ch1-prof-scroll .router-link-exact-active { border-color: var(--ch1-ac) !important; }

/* ═══ ONLINE USERS STRIP ═══ */
.ch1-online-strip {
  display: flex; align-items: center; gap: 10px; padding: 10px 14px 8px;
  background: var(--ch1-surf);
  overflow-x: auto; flex-shrink: 0; -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.ch1-online-strip::-webkit-scrollbar { display: none; }
.ch1-online-av-wrap { position: relative; cursor: pointer; flex-shrink: 0; transition: transform .12s; }
.ch1-online-av-wrap:hover { transform: scale(1.1); }
.ch1-online-av {
  width: 36px; height: 36px; border-radius: 50%;
  display: grid; place-items: center;
  font-size: 12px; font-weight: 700; color: #fff;
  border: 2px solid var(--ch1-surf);
  box-shadow: 0 1px 4px rgba(0,0,0,.12);
}
.ch1-online-dot {
  position: absolute; bottom: 1px; right: 1px;
  width: 9px; height: 9px; border-radius: 50%;
  background: var(--ch1-online); border: 2px solid var(--ch1-surf);
}
.ch1-online-empty { font-size: 11px; color: var(--ch1-t3); font-style: italic; padding: 4px 2px; }

/* ═══ SPLIT VIEW ═══ */
.ch1-split { display: flex; flex: 1; overflow: hidden; min-height: 0; }

/* LEFT */
.ch1-left {
  width: 100%; display: flex; flex-direction: column;
  background: var(--ch1-surf); border-right: 1px solid var(--ch1-brd);
  flex-shrink: 0; min-width: 0; overflow: hidden;
}
@media (max-width: 767px) { .ch1-left.ch1-left-hidden { display: none; } }
@media (min-width: 768px)  { .ch1-left { width: 320px; } }
@media (min-width: 1200px) { .ch1-left { width: 360px; } }

.ch1-list-header {
  display: flex; align-items: center; gap: 8px; padding: 8px 14px 10px;
  background: var(--ch1-surf); border-bottom: 1px solid var(--ch1-brd); flex-shrink: 0;
}
.ch1-search-wrap { flex: 1; position: relative; }
.ch1-search-ico {
  position: absolute; left: 10px; top: 50%; transform: translateY(-50%);
  width: 13px; height: 13px; stroke: var(--ch1-t3); fill: none;
  stroke-width: 2; pointer-events: none;
}
.ch1-search-input {
  width: 100%; box-sizing: border-box;
  background: var(--ch1-surf2); border: 1.5px solid var(--ch1-brd2);
  border-radius: 22px; padding: 8px 30px 8px 32px;
  color: var(--ch1-t1); font-size: 12.5px; outline: none;
  transition: border-color .15s, background .15s; font-family: inherit;
}
.ch1-search-input::placeholder { color: var(--ch1-t3); }
.ch1-search-input:focus { border-color: var(--ch1-ac); }
.ch1-search-clear {
  position: absolute; right: 8px; top: 50%; transform: translateY(-50%);
  cursor: pointer; color: var(--ch1-t3); padding: 2px;
}
.ch1-search-clear svg { width: 12px; height: 12px; stroke: currentColor; fill: none; stroke-width: 2; }
.ch1-new-btn {
  width: 36px; height: 36px; border-radius: 50%;
  background: var(--ch1-ac-dim); border: 1.5px solid var(--ch1-ac-glow);
  color: var(--ch1-ac); cursor: pointer; flex-shrink: 0;
  display: grid; place-items: center; transition: background .12s;
}
.ch1-new-btn:hover { background: var(--ch1-ac); color: #fff; }
.ch1-new-btn svg { width: 14px; height: 14px; stroke: currentColor; fill: none; stroke-width: 2.5; }

/* New conversation picker */
.ch1-new-conv-picker {
  padding: 10px; background: var(--ch1-surf2);
  border-bottom: 1px solid var(--ch1-brd);
  max-height: 240px; overflow-y: auto; flex-shrink: 0;
}
.ch1-new-conv-lbl {
  font-size: 9px; font-weight: 700; text-transform: uppercase;
  letter-spacing: .5px; color: var(--ch1-t3); margin-bottom: 7px;
}
.ch1-new-conv-item {
  display: flex; align-items: center; gap: 8px;
  padding: 7px 6px; border-radius: 8px; cursor: pointer; transition: background .12s;
}
.ch1-new-conv-item:hover { background: var(--ch1-brd); }
.ch1-new-conv-av {
  width: 28px; height: 28px; border-radius: 50%;
  display: grid; place-items: center;
  font-size: 10px; font-weight: 700; color: #fff; flex-shrink: 0;
}
.ch1-new-conv-name { flex: 1; font-size: 12px; font-weight: 500; color: var(--ch1-t1); }
.ch1-new-conv-dot { width: 7px; height: 7px; border-radius: 50%; background: var(--ch1-online); flex-shrink: 0; }

/* Conversation list */
.ch1-conv-list { flex: 1; overflow-y: auto; -webkit-overflow-scrolling: touch; }
.ch1-conv-empty {
  display: flex; flex-direction: column; align-items: center;
  gap: 10px; padding: 40px 20px; color: var(--ch1-t3);
}
.ch1-conv-empty svg { width: 32px; height: 32px; stroke: currentColor; fill: none; stroke-width: 1.5; }
.ch1-conv-empty span { font-size: 13px; }
.ch1-conv-item {
  display: flex; align-items: center; gap: 12px; padding: 11px 14px;
  cursor: pointer; transition: background .12s; position: relative;
}
/* Inset separator — starts after the avatar gutter, not edge-to-edge */
.ch1-conv-item::after {
  content: ''; position: absolute; bottom: 0;
  left: 70px; right: 0;
  height: 1px; background: var(--ch1-brd);
}
.ch1-conv-item:last-child::after { display: none; }
.ch1-conv-item:hover { background: var(--ch1-surf2); }
.ch1-conv-item.ch1-conv-active { background: rgba(99,102,241,.08); box-shadow: inset 3px 0 0 var(--ch1-ac); }
.ch1-conv-item.ch1-conv-unread { background: rgba(99,102,241,.05); }
.ch1-conv-av-wrap { position: relative; flex-shrink: 0; }
.ch1-conv-av {
  width: 42px; height: 42px; border-radius: 50%;
  display: grid; place-items: center;
  font-size: 14px; font-weight: 700; color: #fff;
  box-shadow: 0 2px 6px rgba(0,0,0,.15);
  flex-shrink: 0;
}
.ch1-conv-online-dot {
  position: absolute; bottom: 0; right: 0;
  width: 10px; height: 10px; border-radius: 50%;
  background: var(--ch1-online); border: 2px solid var(--ch1-surf);
}
.ch1-conv-body { flex: 1; min-width: 0; }
.ch1-conv-row1 { display: flex; align-items: baseline; gap: 6px; }
.ch1-conv-name { flex: 1; font-size: 13px; font-weight: 500; color: var(--ch1-t1); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.ch1-conv-name-bold { font-weight: 700; color: #1a1a1a; }
.ch1-conv-time { font-size: 10px; color: var(--ch1-t3); flex-shrink: 0; }
.ch1-conv-row2 { display: flex; align-items: center; gap: 6px; margin-top: 3px; }
.ch1-conv-preview { flex: 1; font-size: 11px; color: var(--ch1-t2); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.ch1-conv-badge {
  background: var(--ch1-ac); color: #fff;
  font-size: 9px; font-weight: 700;
  padding: 2px 6px; border-radius: 10px; flex-shrink: 0;
}

/* ═══ RIGHT PANEL ═══ */
.ch1-right {
  flex: 1; display: flex; flex-direction: column;
  background: var(--ch1-surf); min-width: 0; overflow: hidden;
}
@media (max-width: 767px) {
  .ch1-right {
    position: fixed; top: 0; left: 0; right: 0; bottom: 0;
    z-index: 100; transform: translateX(100%); transition: transform .25s cubic-bezier(.4,0,.2,1);
  }
  .ch1-right.ch1-right-visible { transform: translateX(0); }
}

.ch1-no-conv {
  flex: 1; display: flex; flex-direction: column; align-items: center;
  justify-content: center; gap: 12px; color: var(--ch1-t3);
}
.ch1-no-conv svg { width: 40px; height: 40px; stroke: currentColor; fill: none; stroke-width: 1.5; }
.ch1-no-conv span { font-size: 14px; }

/* Thread header */
.ch1-thread-hdr {
  display: flex; align-items: center; gap: 10px; padding: 10px 14px;
  background: var(--ch1-surf); border-bottom: 1px solid var(--ch1-brd);
  flex-shrink: 0; min-height: 56px;
}
.ch1-back-btn {
  background: none; border: none; cursor: pointer;
  color: var(--ch1-t2); padding: 4px; transition: color .12s; display: block;
}
.ch1-back-btn:hover { color: var(--ch1-t1); }
.ch1-back-btn svg { width: 20px; height: 20px; stroke: currentColor; fill: none; stroke-width: 2.5; }
@media (min-width: 768px) { .ch1-back-btn { display: none; } }
.ch1-thread-av {
  width: 36px; height: 36px; border-radius: 50%;
  display: grid; place-items: center;
  font-size: 13px; font-weight: 700; color: #fff; flex-shrink: 0;
}
.ch1-thread-meta { flex: 1; min-width: 0; }
.ch1-thread-name { font-size: 14px; font-weight: 600; color: var(--ch1-t1); }
.ch1-thread-sub { font-size: 10px; color: var(--ch1-t3); margin-top: 2px; }
.ch1-thread-sub-status { display: flex; align-items: center; gap: 5px; margin-top: 3px; }
.ch1-shift-dot { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }
.ch1-shift-dot.on  { background: #10b981; box-shadow: 0 0 0 2px rgba(16,185,129,.2); }
.ch1-shift-dot.off { background: #9ca3af; }
.ch1-shift-live { font-size: 10px; font-weight: 700; color: #10b981; }
.ch1-shift-off  { font-size: 10px; font-weight: 600; color: var(--ch1-t3); }
.ch1-online-pill { font-size: 9px; font-weight: 700; color: #6366f1; background: rgba(99,102,241,.1); border-radius: 8px; padding: 1px 6px; margin-left: 2px; }
.ch1-thread-action-btn {
  width: 30px; height: 30px; border-radius: 8px;
  background: none; border: 1px solid var(--ch1-brd2);
  color: var(--ch1-t2); cursor: pointer;
  display: grid; place-items: center; transition: all .12s; flex-shrink: 0;
}
.ch1-thread-action-btn:hover  { background: var(--ch1-surf2); color: var(--ch1-t1); }
.ch1-thread-action-btn.on     { background: var(--ch1-ac-dim); border-color: var(--ch1-ac); color: var(--ch1-ac); }
.ch1-thread-action-btn svg { width: 14px; height: 14px; stroke: currentColor; fill: none; stroke-width: 2; }

/* ═══ AGENT STATS BAR ═══ */
.ch1-stats-bar {
  background: var(--ch1-surf2); border-bottom: 1px solid var(--ch1-brd);
  padding: 10px 14px; flex-shrink: 0;
}
.ch1-stats-title {
  font-size: 9px; font-weight: 700; text-transform: uppercase;
  letter-spacing: .5px; color: var(--ch1-t3); margin-bottom: 8px;
}
.ch1-stats-grid {
  display: grid; grid-template-columns: repeat(4, 1fr); gap: 6px;
}
@media (min-width: 600px) { .ch1-stats-grid { grid-template-columns: repeat(8, 1fr); } }
.ch1-stat-card {
  background: var(--ch1-surf); border-radius: 8px;
  border: 1px solid var(--ch1-brd2); padding: 6px 8px; text-align: center;
}
.ch1-stat-val {
  font-size: 18px; font-weight: 800; color: var(--sc, var(--ch1-ac));
  line-height: 1;
}
.ch1-stat-lbl { font-size: 8px; color: var(--ch1-t3); text-transform: uppercase; letter-spacing: .3px; margin-top: 3px; }

/* ═══ MESSAGES ═══ */
.ch1-messages {
  flex: 1; overflow-y: auto; padding: 12px 14px 8px;
  display: flex; flex-direction: column; gap: 2px;
  -webkit-overflow-scrolling: touch;
}
.ch1-msgs-loading { display: flex; align-items: center; justify-content: center; padding: 30px; flex: 1; }
.ch1-spinner {
  width: 22px; height: 22px; border-radius: 50%;
  border: 2px solid var(--ch1-brd2); border-top-color: var(--ch1-ac);
  animation: ch1spin .8s linear infinite;
}
.ch1-date-sep { display: flex; align-items: center; gap: 10px; margin: 14px 0 8px; color: var(--ch1-t3); }
.ch1-date-sep::before, .ch1-date-sep::after { content: ''; flex: 1; height: 1px; background: var(--ch1-brd); }
.ch1-date-sep span { font-size: 10px; font-weight: 600; white-space: nowrap; }

.ch1-msg-row { display: flex; align-items: flex-end; gap: 7px; margin-bottom: 2px; }
.ch1-msg-row.ch1-msg-own { flex-direction: row-reverse; }
.ch1-msg-av {
  width: 26px; height: 26px; border-radius: 50%;
  display: grid; place-items: center;
  font-size: 9px; font-weight: 700; color: #fff;
  flex-shrink: 0; align-self: flex-end;
}
.ch1-msg-av-spacer { width: 26px; flex-shrink: 0; }
.ch1-msg-wrap { display: flex; flex-direction: column; max-width: 75%; }
.ch1-msg-row.ch1-msg-own .ch1-msg-wrap { align-items: flex-end; }
.ch1-msg-sender-name { font-size: 10px; font-weight: 600; color: var(--ch1-t3); margin-bottom: 3px; padding-left: 10px; }

/* Bubbles */
.ch1-bubble {
  display: inline-flex; align-items: flex-end; gap: 8px;
  padding: 9px 13px; border-radius: 16px;
  line-height: 1.45; word-break: break-word; max-width: 100%;
}
.ch1-bubble-own   { background: var(--ch1-ac); border-bottom-right-radius: 4px; }
.ch1-bubble-other { background: #f4f4f4; border: 1px solid #e8e8e8; border-bottom-left-radius: 4px; }
.ch1-bubble-text  { font-size: 13px; color: var(--ch1-t1); flex: 1; }
.ch1-bubble-own .ch1-bubble-text { color: #fff; }
.ch1-bubble-ts { font-size: 9px; color: rgba(255,255,255,.6); white-space: nowrap; flex-shrink: 0; align-self: flex-end; }
.ch1-bubble-other .ch1-bubble-ts { color: var(--ch1-t3); }

/* File message */
.ch1-file-msg { display: flex; align-items: center; gap: 8px; flex: 1; }
.ch1-file-msg svg { width: 18px; height: 18px; stroke: currentColor; fill: none; stroke-width: 1.5; flex-shrink: 0; }
.ch1-file-link { font-size: 12px; font-weight: 600; color: inherit; text-decoration: underline; flex: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 160px; }
.ch1-file-size { font-size: 9px; opacity: .7; white-space: nowrap; }

/* Voice message */
.ch1-voice-msg { display: flex; align-items: center; gap: 8px; flex: 1; }
.ch1-voice-play {
  width: 28px; height: 28px; border-radius: 50%;
  background: rgba(255,255,255,.15); border: none;
  color: inherit; cursor: pointer;
  display: grid; place-items: center; flex-shrink: 0;
  transition: background .12s;
}
.ch1-voice-play:hover { background: rgba(255,255,255,.25); }
.ch1-voice-play svg { width: 10px; height: 10px; stroke: none; fill: currentColor; }
.ch1-voice-wave { display: flex; align-items: center; gap: 2px; height: 24px; }
.ch1-wave-bar { width: 2px; background: currentColor; border-radius: 1px; opacity: .7; flex-shrink: 0; }
.ch1-voice-dur { font-size: 10px; opacity: .7; white-space: nowrap; flex-shrink: 0; }

/* Typing indicator */
.ch1-typing-row { display: flex; align-items: center; gap: 7px; margin-top: 4px; }
.ch1-typing-bubble {
  display: flex; align-items: center; gap: 8px;
  padding: 8px 13px; border-radius: 16px; border-bottom-left-radius: 4px;
  background: #f4f4f4; border: 1px solid #e8e8e8;
}
.ch1-typing-name { font-size: 11px; color: var(--ch1-t3); font-style: italic; }
.ch1-typing-dots { display: flex; align-items: center; gap: 3px; }
.ch1-typing-dots span {
  width: 5px; height: 5px; border-radius: 50%; background: var(--ch1-t3);
  animation: ch1typingDot 1.2s infinite;
}
.ch1-typing-dots span:nth-child(2) { animation-delay: .2s; }
.ch1-typing-dots span:nth-child(3) { animation-delay: .4s; }

/* ═══ INPUT BAR ═══ */
.ch1-input-bar {
  display: flex; align-items: flex-end; gap: 6px; padding: 10px 12px;
  background: #fff; border-top: 1px solid var(--ch1-brd); flex-shrink: 0;
}
.ch1-attach-btn, .ch1-voice-btn {
  width: 36px; height: 36px; border-radius: 50%;
  background: none; border: 1px solid var(--ch1-brd2);
  color: var(--ch1-t2); cursor: pointer; flex-shrink: 0;
  display: grid; place-items: center; transition: all .12s;
}
.ch1-attach-btn:hover { background: var(--ch1-surf2); color: var(--ch1-t1); }
.ch1-voice-btn:hover  { background: var(--ch1-surf2); color: var(--ch1-t1); }
.ch1-voice-btn.recording { background: rgba(239,68,68,.15); border-color: #ef4444; color: #ef4444; animation: ch1blink 1s infinite; }
.ch1-attach-btn svg, .ch1-voice-btn svg {
  width: 14px; height: 14px; stroke: currentColor; fill: none;
  stroke-width: 2; stroke-linecap: round; stroke-linejoin: round;
}
.ch1-textarea {
  flex: 1; background: #fff; border: 1px solid var(--ch1-brd);
  border-radius: 20px; padding: 9px 14px;
  color: var(--ch1-t1); font-size: 13px; font-family: inherit;
  outline: none; resize: none; overflow-y: auto;
  min-height: 38px; max-height: 140px; line-height: 1.4;
  transition: border-color .15s; display: block;
}
.ch1-textarea::placeholder { color: var(--ch1-t3); }
.ch1-textarea:focus { border-color: var(--ch1-ac); }
.ch1-send-btn {
  width: 38px; height: 38px; border-radius: 50%; flex-shrink: 0;
  background: #eeedea; border: 1px solid #e4e3df;
  color: var(--ch1-t3); cursor: pointer;
  display: grid; place-items: center; transition: all .15s;
}
.ch1-send-btn.active { background: var(--ch1-ac); border-color: var(--ch1-ac); color: #fff; }
.ch1-send-btn:disabled { cursor: default; }
.ch1-send-btn.active:hover { opacity: .9; transform: scale(1.05); }
.ch1-send-btn svg { width: 16px; height: 16px; stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.ch1-input-hint {
  text-align: center; font-size: 9px; color: var(--ch1-t3);
  padding: 2px 0 5px; background: #fff; flex-shrink: 0;
}

/* ═══ KEYFRAMES ═══ */
@keyframes ch1spin       { to { transform: rotate(360deg); } }
@keyframes ch1pulse      { 0%,100%{opacity:1}50%{opacity:.5} }
@keyframes ch1blink      { 0%,100%{opacity:1}50%{opacity:.3} }
@keyframes ch1typingDot  { 0%,80%,100%{opacity:.3;transform:translateY(0)}40%{opacity:1;transform:translateY(-4px)} }

/* ── Hide right panel (replaced by top-strip) ─────── */
.c1-chat-page .c1-panel { display: none !important; }

/* ══ TEAM CHANNELS SIDEBAR ══════════════════════════ */
.ch1-team-channels-section {
  padding: 0 0 12px;
  border-top: 1px solid var(--ch1-brd);
  margin-top: 4px;
}
.ch1-section-hdr {
  font-size: 10px; font-weight: 700; letter-spacing: .08em;
  color: var(--ch1-t3); padding: 10px 14px 5px;
  text-transform: uppercase;
}
.ch1-team-ch-row {
  display: flex; align-items: center; gap: 9px;
  padding: 8px 12px; cursor: pointer;
  position: relative; overflow: hidden;
  transition: background .12s;
}
.ch1-team-ch-row:hover { background: var(--ch1-surf2); }
.ch1-team-ch-row.ch1-team-ch-active { background: var(--ch1-surf2); }
.ch1-team-ch-row.ch1-team-ch-locked { opacity: .55; cursor: not-allowed; }
.ch1-team-ch-border {
  position: absolute; left: 0; top: 0; bottom: 0;
  width: 3px; border-radius: 0 2px 2px 0;
}
.ch1-team-ch-av {
  width: 34px; height: 34px; border-radius: 10px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  font-size: 14px; font-weight: 700;
}
.ch1-team-ch-body { flex: 1; min-width: 0; }
.ch1-team-ch-name {
  font-size: 13px; font-weight: 600; color: var(--ch1-t1);
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.ch1-team-ch-sub { font-size: 11px; color: var(--ch1-t3); margin-top: 1px; }
.ch1-team-ch-lock { color: var(--ch1-t3); flex-shrink: 0; }

/* ══ TEAM CHANNEL THREAD HEADER STYLES ══════════════ */
.ch1-team-sub { display: flex; align-items: center; gap: 5px; }
.ch1-team-badge {
  font-size: 10px; font-weight: 700; padding: 1px 6px;
  border-radius: 8px; letter-spacing: .04em;
}
.ch1-team-member-count { font-size: 11px; color: var(--ch1-t3); }

/* ══ PINNED MESSAGES SLOT ═══════════════════════════ */
.ch1-pinned-slot {
  display: flex; align-items: center; gap: 6px;
  padding: 6px 14px; font-size: 11px; color: var(--ch1-t3);
  background: var(--ch1-surf2); border-bottom: 1px solid var(--ch1-brd);
}
.ch1-pinned-lbl { font-weight: 700; color: var(--ch1-t2); }
.ch1-pinned-empty { margin-left: auto; font-style: italic; }
</style>
